import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2, AlertCircle, Sparkles, Building2, MapPin, Eye } from 'lucide-react';

export const hotelInspectionsMap = {
  'protur-safari-park': 'inspektion-protur-safari-park',
  'hoposa-daina': 'inspektion-hoposa-daina',
  'aparthotel-flora': 'inspektion-aparthotel-flora',
  'cabot-pollensa-park': 'inspektion-cabot-pollensa-park',
  'zafiro-mallorca': 'inspektion-zafiro-mallorca',
  'grupotel-playa-palma': 'inspektion-grupotel-playa-palma',
  'zoetry-mallorca': 'inspektion-zoetry-mallorca',
  'forum-boutique-hotel-spa': 'inspektion-forum-boutique-hotel-spa',
  'quartier-libre-marais': 'inspektion-quartier-libre-marais',
  'puerto-azul-suite-hotel': 'inspektion-puerto-azul-suite-hotel',
};

export const inspectionArticles_da = [
  {
    id: 'inspektion-protur-safari-park',
    hotelId: 'protur-safari-park',
    title: '⭐ Inspektion af Protur Safari Park Aparthotel – Sa Coma, Mallorca ⭐️',
    date: 'maj 2025',
    category: 'Hotelinspektioner',
    categories: ['Hotelinspektioner', 'Handicaprejser', 'Destinationer', 'Praktisk info'],
    intro: 'Protur Safari Park er et hotel, hvor der virkelig er liv og feriestemning fra morgen til aften. Læs vores personlige inspektion af det store familiehotel, pools og de rummelige handicapværelser i flade Sa Coma.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/6a685c48-3be8-45bf-88cd-a6f4d4abd52a.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/6a685c48-3be8-45bf-88cd-a6f4d4abd52a.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejsers personlige hotelinspektion</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Protur Safari Park Aparthotel</strong> • Område: Sa Coma, Mallorca • Inspiceret personligt af Alora Rejser
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Protur Safari Park er et hotel, hvor der virkelig er liv og feriestemning fra morgen til aften🥳
        </p>

        <p>
          Det er et udpræget børne- og familiehotel, og her sker noget næsten overalt – men på den gode måde⭐️
        </p>

        <p>
          Hotellet er stort, flot og stilfuldt, jeg følte dog ved første øjekast det var lidt voldsom ved hoved poolen, men jo mere jeg bevægede mig ind på det kæmpe hotelområde, så jeg at man også finder hyggelige områder, hvor man kan slå sig ned og nyde ferien i lidt roligere omgivelser både med en cold cola og lidt snacks eller bade med de mindre børn i fred og ro❤️
        </p>

        <p>
          Jo mere jeg kom rundt på den virkelig store hotel grund, jo mere ændrede mit indtryk sig😉
          For Protur Safari Park er meget mere end den store fælles pool. Rundt omkring på området gemmer der sig andre og mere rolige steder, hvor man kan trække sig lidt væk fra det hele, og pludselig begyndte jeg faktisk at synes, at hotellet var både utrolig spændende og yderst charmerende🌸🌺
        </p>

        <div className="bg-stone-50 border border-stone-200/80 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-lg">
            Aktiviteter og sjov for hele familien 🧸🦄🚂🛝
          </h4>
          <p>
            For børnene er her et væld af muligheder. Der er store poolområder, vandleg og vandland for både mindre og større børn, og i den lille aktivitetspark kan børnene køre rundt i små biler, hoppe på trampoliner og gå på opdagelse blandt de forskellige aktiviteter som poolbord, bordtennis osv.
          </p>
          <p>
            Hotellet tilbyder også miniklub, minidisco og familieunderholdning, så der er masser at glæde sig til både i løbet af dagen og om aftenen🪩🎉😎
          </p>
          <p>
            På den modsatte side af vejen ligger desuden La Reserva, Proturs store vand- og aktivitetsområde💦💦 Det hører til resortområdet, men der betales separat for adgang. Her kan familien få endnu mere vand, leg og sjov, hvis man har lyst til at fylde lidt ekstra på ferieprogrammet.🤗
          </p>
        </div>

        <p>
          Hotellet har en stor og varieret buffet i deres restaurant med masser at vælge imellem til både børn og voksne, og generelt synes jeg, at hotellet fremstår både flot og stilfuldt🙏🏼
        </p>

        <div className="bg-emerald-50 border border-emerald-200/80 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-emerald-950 text-lg flex items-center gap-2">
            <span>♿ Tilgængelighed og handicapværelser</span>
          </h4>
          <p className="text-slate-700">
            Tilgængeligheden gjorde også et rigtig godt indtryk på mig. De handicapvenlige værelser er store og rummelige med rigtig god plads til at komme omkring med kørestol. Der er fin plads omkring sengen, og badeværelset er stort, åbent og på ingen måde klemt, rigtig go vendeplads derude🤗
          </p>
          <p className="text-slate-700">
            Det handicapvenlige værelse kan rumme en familie med 2 voksne og 2 børn, hvilket er et stort plus, da gode tilgængelige familieværelser med plads til fire ikke altid er nemme at finde! 🙏🏼
          </p>
          <p className="text-slate-700">
            Der er desuden sovesofa og et lille tekøkken, som giver nogle gode praktiske muligheder under opholdet🤗
          </p>
          <p className="text-slate-700">
            Værelset har egen solrig altan☀️ Der er en mindre kant ved udgangen, men her har hotellet tænkt en rigtig fin løsning ind. I de handicapvenlige værelser står der ramper klar, som kan lægges over kanten, hvis den er for høj til den kørestol, man benytter. På den måde kan man stadig komme nemt ud og nyde altanen.
          </p>
          <p className="text-slate-700">
            Der er også mulighed for parkering ved hotellet, hvilket er praktisk, hvis man har lejebil🛻
          </p>
        </div>

        <div className="space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-lg">
            Beliggenheden i flade Sa Coma ⭐️🏖️
          </h4>
          <p>
            Beliggenheden er endnu et stort plus⭐️ Protur Safari Park ligger i Sa Coma, som er et rigtig dejligt område, når man rejser med kørestol. Terrænet er meget fladt og derfor nemt at komme rundt i, og ikke langt fra hotellet ligger Sa Comas fantastiske, brede tilgængelig sandstrand med det smukkeste klare, turkisblå vand😍
          </p>
          <p>
            Stranden har samtidig gode handicapfaciliteter som strandkørestole og handicap toilet, så strandlivet også kan blive en naturlig del af ferien🏖️☀️
          </p>
        </div>

        <div className="bg-[#99A18C]/15 border border-[#99A18C]/30 p-6 sm:p-8 rounded-3xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-xl flex items-center gap-2">
            <span>❤️ Aloras vurdering</span>
          </h4>
          <p className="text-slate-700">
            Protur Safari Park overraskede mig. Mit første indtryk ved den store pool var et hotel med rigtig meget liv og måske lidt for meget larm. Men efter at have gået rundt og oplevet, hvor stort området er, og hvor mange forskellige muligheder der faktisk findes, ændrede jeg helt opfattelse!
          </p>
          <p className="text-slate-700">
            Her kan børnene få lov til at bade, lege, hoppe, køre biler, danse til minidisco og være med i aktiviteter – mens familien samtidig kan søge mod de roligere områder, når der er brug for det🙏🏼🥰
          </p>
          <p className="text-slate-700">
            Kombinationen af de mange oplevelser, de store handicapvenlige familieværelser og beliggenheden i flade, skønne Sa Coma gør Protur Safari Park til et hotel, jeg personligt synes har rigtig meget charme.
          </p>
          <p className="text-slate-900 font-semibold italic pt-2">
            Og da jeg gik derfra, var min tanke faktisk: Det her sted ville jeg have elsket at opleve sammen med min egen søn, da han var lille. ❤️
          </p>
        </div>

        {/* Billede i bunden (første billede fra hotellet) */}
        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/6a685c48-3be8-45bf-88cd-a6f4d4abd52a.jpeg"
              alt="Protur Safari Park Aparthotel"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">Se flere detaljer og faciliteter for Protur Safari Park</p>
              <p className="text-xs text-slate-500">Se værelsesdetaljer, priser, faciliteter og billeder</p>
            </div>
            <Link
              to="/da/hotel/protur-safari-park"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>Gå til hotelsiden</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-hoposa-daina',
    hotelId: 'hoposa-daina',
    title: '⭐ Hotel inspektion af Hoposa Daina Adults Only – Port de Pollença ⭐️',
    date: 'juni 2025',
    category: 'Hotelinspektioner',
    categories: ['Hotelinspektioner', 'Handicaprejser', 'Destinationer'],
    intro: 'Hoposa Daina Adults Only er et 10 ud af 10-hotel for voksne, der vil bo smukt, eksklusivt og med det ikoniske poolområde bygget ud over havet ved Pine Walk i Port de Pollença.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/65a6d291-381c-4b22-8b2b-c8d3a31d8f62.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/65a6d291-381c-4b22-8b2b-c8d3a31d8f62.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejsers personlige hotelinspektion</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Hoposa Daina Adults Only</strong> • Område: Port de Pollença, Mallorca • Inspiceret personligt af Alora Rejser
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Der er nogle hoteller, hvor man næsten med det samme mærker, at her er noget særligt – og sådan havde jeg det med Hoposa Daina😍
        </p>

        <p>
          Allerede når man træder indenfor, bliver man mødt af en utrolig smuk og elegant stil. Det føles næsten lidt som at træde ind i en anden tidslomme, men på den helt rigtige måde🌸
          Her er klassisk charme, små hyggelige rum og fine detaljer overalt, og samtidig føles hotellet eksklusivt og gennemført🥰
        </p>

        <p>
          Restauranten er noget af det hyggeligste. Den er ikke stor og upersonlig, men består af små, stemningsfulde områder, hvor man kan sidde i ro og kigge ud mod vandet☀️
          Maden er virkelig lækker og af en kvalitet, der passer perfekt til resten af hotellet🤗👩‍🍳
        </p>

        <div className="bg-stone-50 border border-stone-200/80 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-lg">
            Direkte ved Pine Walk i smørhullet af Port de Pollença 🏖️
          </h4>
          <p>
            Og så er der beliggenheden🙏🏼 🥳
            Hoposa Daina ligger simpelthen lige i smørhullet af Port de Pollença, direkte ved den skønne Pine Walk. Når man træder udenfor hotellet, har man byen, restauranterne, butikkerne, promenaden og vandet lige omkring sig😍🥳
          </p>
          <p>
            Det er sådan et sted, hvor man ikke behøver planlægge ret meget – man går bare ud ad døren, og så er ferien der🏖️
          </p>
        </div>

        <div className="bg-sky-50 border border-sky-100 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-sky-950 text-lg">
            Ikonisk pool bygget ud over havet med poollift 🌊😎
          </h4>
          <p className="text-slate-700">
            På den anden side af Pine Walk ligger hotellets helt fantastiske poolområde. Swimmingpoolen er bygget ud over havet, og det må være et af de smukkeste steder jeg har set, at man kan ligge og nyde sin ferie😎
            Her føles det næsten, som om pool og hav smelter sammen😍
          </p>
          <p className="text-slate-700 font-semibold">
            Poolen har poollift, så der også er tænkt på adgangen til vandet🤗
          </p>
          <p className="text-slate-700">
            Ved poolen ligger desuden en hyggelig poolbar, og mange aftener om ugen er der livemusik🪩🎉
            Det giver området en skøn stemning og lidt liv om aftenen, uden at hotellet mister den elegante og afslappede atmosfære🌺
          </p>
        </div>

        <div className="bg-emerald-50 border border-emerald-200/80 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-emerald-950 text-lg">
            Værelser og vigtige tilgængelighedsdetaljer ♿
          </h4>
          <p className="text-slate-700">
            Værelserne er lige så stilfulde som resten af hotellet. Det handicapvenlige værelse, jeg så, havde rigtig god plads omkring sengen, et stort og rummeligt badeværelse og ikke mindst den dejligste altan med udsigt mod vandet🌊
            Et virkelig skønt sted at sidde og nyde morgenkaffen eller afslutte dagen😍
          </p>
          <div className="bg-amber-50 border border-amber-200 p-4 rounded-xl space-y-2 text-amber-950 text-sm">
            <p className="font-bold flex items-center gap-1.5 text-amber-900">
              <AlertCircle size={16} />
              Vigtigt at være opmærksom på ved elevatoren:
            </p>
            <p>
              Elevatoren på selve Daina er kun ca. <strong>70 cm bred</strong>, og derfor vil den ikke kunne bruges af alle med kørestole😣
            </p>
            <p>
              <strong>Heldigvis findes der en anden mulighed:</strong> Lige bag hotellet ligger Hoposas tilhørende lejlighedskompleks. Her kan man bo i små lejligheder og stadig benytte samme restaurant og det skønne poolområde ved havet. Ved lejlighederne er der trappelift til det handicapvenlige værelse, så også her skal vi naturligvis sikre os, at løsningen passer til den enkelte gæsts behov og kørestol🙏🏼
            </p>
          </div>
        </div>

        <div className="bg-[#99A18C]/15 border border-[#99A18C]/30 p-6 sm:p-8 rounded-3xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-xl flex items-center gap-2">
            <span>⭐️⭐️⭐️ Aloras konklusion: 10 ud af 10-hotel!</span>
          </h4>
          <p className="text-slate-700">
            Bortset fra elevatorens bredde har jeg virkelig svært ved at finde noget at sætte en finger på🥳
            Kombinationen af beliggenheden, den smukke stil, maden, værelserne, udsigten og det helt særlige poolområde gør Hoposa Daina til et hotel, der skiller sig ud🤗😎
          </p>
          <p className="text-slate-900 font-bold italic pt-2">
            For mig er det ganske enkelt et 10 ud af 10-hotel! Et sted til voksne, der gerne vil bo smukt og eksklusivt – men samtidig lige midt i livet og charmen i Port de Pollença⭐️⭐️⭐️
          </p>
        </div>

        {/* Billede i bunden */}
        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/65a6d291-381c-4b22-8b2b-c8d3a31d8f62.jpeg"
              alt="Hoposa Daina - Adults Only"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">Se flere detaljer for Hoposa Daina - Adults Only</p>
              <p className="text-xs text-slate-500">Se værelsesdetaljer, priser, faciliteter og billeder</p>
            </div>
            <Link
              to="/da/hotel/hoposa-daina"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>Gå til hotelsiden</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-aparthotel-flora',
    hotelId: 'aparthotel-flora',
    title: '⭐ Inspektion Aparthotel Flora, Port de Pollença ⭐️',
    date: 'juni 2025',
    category: 'Hotelinspektioner',
    categories: ['Hotelinspektioner', 'Handicaprejser', 'Destinationer', 'Praktisk info'],
    intro: 'Aparthotel Flora er en grøn og intim oase midt i Port de Pollença med hyggelige stier, poollift, rummelige lejligheder i stueplan og kort gåafstand til Pine Walk.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/0342bc2b-84b7-4476-8fb4-24a297db4802.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/0342bc2b-84b7-4476-8fb4-24a297db4802.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejsers personlige hotelinspektion</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Aparthotel Flora</strong> • Område: Port de Pollença, Mallorca • Inspiceret personligt af Alora Rejser
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Aparthotel Flora er et af de hoteller, der charmerede mig med det samme🤗
        </p>

        <p>
          Det er lille, hyggeligt og hjemligt, og man får hurtigt følelsen af at være landet i sin egen lille oase midt i Port de Pollença❤️
        </p>

        <p>
          Hotellet består af mindre bygninger, der ligger omringet af de hyggeligste små stier. Her går man mellem oliventræer, bougainvillea og smukke blomster på vej til sin lejlighed, poolen eller den lille bar🌸🌼🌺
        </p>

        <p>
          Det hele er grønt, afslappet og intimt, og fordi hotellet ikke er særlig stort, får det en næsten familiær stemning. Det er et sted, hvor man hurtigt finder sig til rette🤗
        </p>

        <div className="bg-emerald-50 border border-emerald-200/80 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-emerald-950 text-lg">
            Handicapvenlige lejligheder i stueetagen 🌸
          </h4>
          <p className="text-slate-700">
            De handicapvenlige lejligheder ligger i stueetagen og har egen terrasse (med en lille kant ud til), som passer perfekt ind i den afslappede feriestemning🌸
          </p>
          <p className="text-slate-700">
            Lejlighederne er dejligt rummelige og har et lille køkken, så man har friheden til selv at lave lidt morgenmad, frokost eller noget andet, når det passer. Jeg var selv mega glad for køleskabet til drikkevarer og lidt mad🙏🏼
          </p>
          <p className="text-slate-700">
            Lige på den anden side af vejen ligger en SPAR, så det er nemt at fylde køleskabet med det, man har brug for🤗
          </p>
          <div className="bg-amber-50 border border-amber-200 p-4 rounded-xl text-amber-900 text-sm">
            <strong>Obs på badeværelse:</strong> Badeværelset kommer ikke som standard med en fastmonteret badestol (stolen fra terrassen kan dog bruges), men det er muligt at bestille en badestol til opholdet🤗🙏🏼
          </div>
        </div>

        <div className="bg-sky-50 border border-sky-100 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-sky-950 text-lg">
            Poolområdet med poollift og romertrappe 💦🧃
          </h4>
          <p className="text-slate-700">
            Midt mellem de små bygninger ligger hotellets hyggelige poolområde💦 Her er solsenge og en lille poolbar, hvor man kan hente en kold drink eller en snack og bare nyde dagen omkring vandet🧃🍸
          </p>
          <p className="text-slate-700">
            Poolen er opdelt i en lav børnedel på cirka 60 cm og en større pool. Ved den store pool er der <strong>poollift samt romertrappe</strong> ned i vandet🙏🏼
          </p>
          <p className="text-xs text-slate-500 italic">
            Det er dog værd at være opmærksom på, at liften ikke giver adgang til den lave børnepool, hvis man rejser med et barn, der har behov for lift🌼
          </p>
        </div>

        <p>
          Flora tilbyder også en enkel morgenmad i deres meget lille hyggelige restaurant, men noget af det dejlige ved at bo her er, at man ikke behøver være bundet til hotellet. Kun et par blokke væk ligger Pine Walk og strandpromenaden med havet, stranden, caféerne og de mange restauranter👩‍🍳
          Der ligger også flere muligheder for morgenmad ganske tæt på hotellet, blandt andet lige på den anden side af vejen🤗
        </p>

        <p>
          Det er netop kombinationen, jeg synes gør Flora så skønt: Man bor fredeligt og grønt i sin lille oase, men træder man ud af hotellet, har man Port de Pollença lige omkring sig🥳❤️
        </p>

        <div className="bg-[#99A18C]/15 border border-[#99A18C]/30 p-6 sm:p-8 rounded-3xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-xl">
            Aloras vurdering
          </h4>
          <p className="text-slate-700">
            Flora er ikke et stort og prangende resort – og det er faktisk en del af charmen, hvis du spørger mig!
            Her handler det mere om den hjemlige stemning, blomsterne langs de små stier, sin egen terrasse, en afslappet dag ved poolen og friheden ved at bo i lejlighed🙏🏼🥰
          </p>
          <p className="text-slate-700">
            Samtidig er det et prisvenligt hotel med en virkelig god beliggenhed, og for mig gør det Flora til et rigtig fint fund i Port de Pollença😎
          </p>
          <p className="text-slate-900 font-bold italic pt-2">
            Alora Rejser har selv boet på og inspiceret Aparthotel Flora. Har I særlige behov eller ønsker til jeres ferie, så fortæl mig om dem – så hjælper jeg med at finde den løsning og lejlighed, der passer bedst til jer🤗🏖️❤️
          </p>
        </div>

        {/* Billede i bunden */}
        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/0342bc2b-84b7-4476-8fb4-24a297db4802.jpeg"
              alt="Aparthotel Flora"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">Se flere detaljer for Aparthotel Flora</p>
              <p className="text-xs text-slate-500">Se værelsesdetaljer, priser, faciliteter og billeder</p>
            </div>
            <Link
              to="/da/hotel/aparthotel-flora"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>Gå til hotelsiden</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-cabot-pollensa-park',
    hotelId: 'cabot-pollensa-park',
    title: '✨ Hotelinspektion – Cabot Pollensa Park Spa, Mallorca ✨',
    date: 'juni 2025',
    category: 'Hotelinspektioner',
    categories: ['Hotelinspektioner', 'Handicaprejser', 'Destinationer', 'Praktisk info'],
    intro: 'Cabot Pollensa Park Spa i Port de Pollença byder på hjertevarm service, rummelig bruseplads, pool med lift og romertrappe, børneområde med splash og lækre buffeter tæt på stranden.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/15d24810-470a-4b8c-931c-d98194e78250.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/15d24810-470a-4b8c-931c-d98194e78250.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejsers personlige hotelinspektion</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Cabot Pollensa Park Spa</strong> • Område: Port de Pollença, Mallorca • Inspiceret personligt af Alora Rejser
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Cabot Pollensa Park Spa er sådan et hotel, hvor man hurtigt mærker, at her er der plads til hele familien 💚
        </p>

        <p>
          Hotellet er af lidt ældre karakter, men det opvejes i den grad af en hyggelig feriestemning, et dejligt poolområde og ikke mindst et personale, der får én til at føle sig velkommen fra første øjeblik🤗
        </p>

        <p>
          Jeg oplevede virkelig, at de gerne ville hjælpe og gøre deres bedste for at finde løsninger – og det betyder altså meget, når man rejser med særlige behov 🙏
        </p>

        <p>
          Hotellet ligger i skønne Port de Pollença, tæt på den tilgængelige strand og med den smukke bugt og bjergene der omkranser byen🌄
          Det er et område, jeg rigtig godt kan lide til kørestolsbrugere og familier, fordi man både får strand, ferieby og en dejlig promenade☀️🏖️
        </p>

        <div className="bg-emerald-50 border border-emerald-200/80 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-emerald-950 text-lg">
            ♿ Og hvordan fungerer hotellet så med kørestol?
          </h4>
          <p className="text-slate-700">
            De handicaptilpassede værelser har nogle rigtig fine og brugbare badeværelser, med en meget rummelig bruseplads, som bestemt var et plus ved min inspektion🙏🏼
          </p>
          <div className="bg-amber-50 border border-amber-200 p-4 rounded-xl text-amber-900 text-sm">
            <strong>Vigtig detalje på værelset:</strong> For enden af sengen er der ca. <strong>72 cm</strong> mellem sengen og tv-reolen. Det vil fungere for nogle kørestole, men ikke for alle, og derfor er det vigtigt, at vi kender målene på jeres stol inden booking🤗
          </div>
          <p className="text-slate-700">
            Til gengæld er der trinfri adgang direkte ud på altanen, og her venter den skønneste og mest fantastiske udsigt over poolområdet og videre mod stranden 🌴🌊
            Det er virkelig et sted, hvor man kan sidde og mærke, at man er kommet på ferie😍
          </p>
        </div>

        <div className="bg-sky-50 border border-sky-100 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-sky-950 text-lg">
            Poolområdet med poollift, romertrappe og splash-område 💦😎
          </h4>
          <p className="text-slate-700">
            Poolområdet er efter min mening et af hotellets helt store plusser 💦 Den store pool har poollift og Romertrappe og rejser man med børn, er der et stort og hyggeligt børneområde med børnepool og splash-område, hvor der kan bruges mange timer med sjov og leg💦😎
          </p>
        </div>

        <div className="bg-stone-50 border border-stone-200/80 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-lg">
            Lækker og varieret mad 🥞🍩👨‍🍳
          </h4>
          <p className="text-slate-700">
            Og så skal maden altså også nævnes 😋 Jeg spiste både morgenmad og aftensmad på hotellet, og buffeterne var lækre, store og meget varierede👨‍🍳
          </p>
          <p className="text-slate-700">
            Der var masser at vælge imellem for både børn og voksne – og til morgenmaden blandt andet pandekager, donuts og alt det andet, der gør, at morgenmaden lige bliver lidt mere ferieagtig 🥞🍩
          </p>
        </div>

        <div className="bg-[#99A18C]/15 border border-[#99A18C]/30 p-6 sm:p-8 rounded-3xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-xl">
            Aloras vurdering
          </h4>
          <p className="text-slate-700">
            Cabot Pollensa Park Spa vælger man for den hyggelige stemning, den gode beliggenhed, børnefaciliteterne, den lækre mad og følelsen af at være et sted, hvor personalet faktisk gerne vil have, at ens ferie fungerer🤗❤️
            For mig er det netop dét, der gør hotellet interessant til Alora Rejser 💚
          </p>
          <p className="text-slate-900 font-bold italic pt-2">
            ♿ Jeg har selv besøgt og inspiceret hotellet, så kontakt mig gerne og fortæl lidt om jeres behov og kørestol. Så hjælper jeg med at vurdere, om Cabot Pollensa Park Spa passer til netop jeres ferie🤗
          </p>
        </div>

        {/* Billede i bunden */}
        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/15d24810-470a-4b8c-931c-d98194e78250.jpeg"
              alt="Cabot Pollensa Park Spa"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">Se flere detaljer for Cabot Pollensa Park Spa</p>
              <p className="text-xs text-slate-500">Se værelsesdetaljer, priser, faciliteter og billeder</p>
            </div>
            <Link
              to="/da/hotel/cabot-pollensa-park"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>Gå til hotelsiden</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-zafiro-mallorca',
    hotelId: 'zafiro-mallorca',
    title: '⭐️ Zafiro Mallorca – Hotelinspektion ⭐️',
    date: 'juli 2025',
    category: 'Hotelinspektioner',
    categories: ['Hotelinspektioner', 'Handicaprejser', 'Destinationer', 'Praktisk info'],
    intro: 'Nogle fund gør mig ekstra begejstret! Forestil dig at starte dagen med at åbne terrassedøren og træde direkte ned i din private swim up-pool med tilgængeligt badeværelse på Zafiro Mallorca i Can Picafort.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00018_a11a675b.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00018_a11a675b.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejsers personlige hotelinspektion</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Zafiro Mallorca</strong> • Område: Can Picafort, Mallorca • Inspiceret personligt af Alora Rejser
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          ❤️ Nogle fund gør mig simpelthen ekstra meget begejstret! 🙏🏼🥳
        </p>

        <div className="bg-emerald-50 border border-emerald-200/80 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-emerald-950 text-xl">
            🌴 Privat Swim Up-pool & tilgængeligt badeværelse
          </h4>
          <p className="text-slate-800 leading-relaxed font-medium">
            Forestil dig at starte dagen med at åbne terrassedøren og træde direkte ned i din egen private swim up-pool… og så endda med tilgængeligt badeværelse🤗💦🌴
          </p>
          <p className="text-slate-700">
            Solen varmer allerede, børnene glæder sig til en dag med vandland og sjov, og du kan nyde morgenkaffen i rolige omgivelser – alt sammen på et af Mallorcas mest populære familiehoteller, Zafiro Mallorca.
          </p>
        </div>

        <div className="space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-lg">
            Skønne Can Picafort og den tilgængelige strand 🏖️
          </h4>
          <p>
            Hotellet ligger i skønne Can Picafort, tæt på den kilometerlange tilgængelige sandstrand med lavt, roligt vand😎
          </p>
          <p>
            Strandpromenaden indbyder til hyggelige aftenture, små butikker, iscaféer og restauranter med udsigt over havet. Det er et område, hvor hele familien kan slappe af og nyde ferien i et roligt tempo🏖️
          </p>
        </div>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-lg">
            Vandland, pools og aktiviteter dagen lang ❤️
          </h4>
          <p className="text-slate-700">
            På hotellet er der masser at opleve! Børnene kan boltre sig i vandland, pools og aktiviteter dagen lang, mens de voksne kan nyde de hyggelige omgivelser, en god frokost på terrassen eller bare slappe af ved poolen.
          </p>
          <p className="text-slate-700">
            Her er virkelig tænkt på, at både store og små skal have en fantastisk ferie❤️
          </p>
        </div>

        <div className="bg-[#99A18C]/15 border border-[#99A18C]/30 p-6 sm:p-8 rounded-3xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-xl flex items-center gap-2">
            <span>💚 Unikt fund til handicapvenlige rejser</span>
          </h4>
          <p className="text-slate-700">
            Men det, der gør mig helt ekstra begejstret, er, at det er muligt at få et privat Swim Up-værelse med handicaptilpasset badeværelse. Det er en kombination man meget sjældent finder, og derfor måtte jeg simpelthen dele den med jer🤗🙏🏼❤️
          </p>
          <p className="text-slate-700">
            Hotellet har flere forskellige værelsestyper, og de er ikke ens. Derfor hjælper jeg altid med at finde præcis den løsning, der passer bedst til jeres behov – så I ikke kommer hjem med følelsen af, at I fik det forkerte værelse.
          </p>
          <p className="text-slate-700">
            Hvis I drømmer om en ferie på Mallorca, hvor både komfort, familieoplevelser og tilgængelighed går hånd i hånd, så skriv endelig til mig. Jeg hjælper gerne med at finde den helt rigtige ferie, så I kan rejse afsted med ro i maven.
          </p>
          <p className="text-slate-900 font-bold italic pt-2">
            💚 Det er præcis derfor, Alora Rejser findes – for at finde de særlige unikke steder, hvor alle kan holde ferie sammen❤️
          </p>
        </div>

        {/* Billede i bunden */}
        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00018_a11a675b.jpeg"
              alt="Zafiro Mallorca"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">Se flere detaljer og billeder for Zafiro Mallorca</p>
              <p className="text-xs text-slate-500">Se swim-up værelser, priser, faciliteter og galleri</p>
            </div>
            <Link
              to="/da/hotel/zafiro-mallorca"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>Gå til hotelsiden</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-grupotel-playa-palma',
    hotelId: 'grupotel-playa-palma',
    title: '✨ Hotelinspektion – Grupotel Playa de Palma Suites & Spa, Mallorca ✨',
    date: 'juli 2025',
    category: 'Hotelinspektioner',
    categories: ['Hotelinspektioner', 'Handicaprejser', 'Destinationer', 'Praktisk info'],
    intro: 'Grupotel Playa de Palma Suites & Spa overraskede på den bedst tænkelige måde med fantastisk atmosfære, hjertevarm service, pools med lifts (også på tagterrassen!) og suiter med roll-in shower.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/74f1da8e-d5fd-49ed-bed5-ca5022a89a3e.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/74f1da8e-d5fd-49ed-bed5-ca5022a89a3e.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejsers personlige hotelinspektion</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Grupotel Playa de Palma Suites & Spa</strong> • Område: Playa de Palma, Mallorca • Inspiceret personligt af Alora Rejser
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Da jeg første gang så billederne af Grupotel Playa de Palma Suites & Spa, tænkte jeg, at det så rigtig flot og fint ud! Alligevel var jeg en smule spændt på, om det måske ville føles lidt anonymt🤔 Men hold op, hvor blev jeg positivt overrasket🙏🏼
        </p>

        <p>
          Det her hotel har simpelthen en helt særlig atmosfære🥰 Der er roligt, hyggeligt og utrolig hjemligt, samtidig med at det føles eksklusivt. Det er et af de hoteller, hvor man næsten sænker skuldrene, så snart man træder ind😊
        </p>

        <div className="bg-amber-50/60 border border-amber-200 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-amber-950 text-lg">
            Hjertevarm service og enestående personale 🌞
          </h4>
          <p className="text-slate-700">
            Noget af det, der gjorde allerstørst indtryk på mig, var personalet. Jeg besøgte hotellet i juli – altså midt i højsæsonen, hvor der er allermest travlt. Netop derfor synes jeg, det siger meget om et hotel, hvordan personalet møder gæsterne i den periode! De fortalte selv, at de havde rigtig travlt, men det kunne man nærmest ikke mærke🤗
          </p>
          <p className="text-slate-700">
            Allerede da jeg stod ved receptionen for at tjekke ind, tilbød de at opbevare min kuffert, så de straks kunne vise mig en af de handicapvenlige lejligheder, der tilfældigvis var ledig🤗 Den service og imødekommenhed gjorde virkelig et stort indtryk på mig!🌞
          </p>
        </div>

        <div className="bg-emerald-50 border border-emerald-200/80 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-emerald-950 text-lg">
            De handicapvenlige suiter og badeværelser ♿
          </h4>
          <p className="text-slate-700">
            Den handicapvenlige lejlighed var rigtig flot indrettet med separat soveværelse, opholdsstue og et lille tekøkken med køleskab, vask og to kogeplader. Der var også en hyggelig terrasse i stueplan uden trin, så det var let at komme ud🙏🏼❤️
          </p>
          <p className="text-slate-700">
            Badeværelset fungerede rigtig godt! Der var roll-in shower med brusestol, god vendeplads, mulighed for at køre ind under vasken samt armstøtter ved toilettet🤗 Jeg kunne personligt godt have ønsket, at bruseområdet havde været en smule mere åbent, men samlet set fungerede løsningen rigtig fint!
          </p>
        </div>

        <div className="bg-sky-50 border border-sky-100 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-sky-950 text-lg">
            Pools med poollift & tagterrasse med panoramaudsigt 🍹🌊
          </h4>
          <p className="text-slate-700">
            Hotellet har to store poolområder i stueplan, og begge pools har både poollift og brede romertrapper med gelænder😎 Det giver mulighed for at vælge den løsning, der passer bedst til den enkelte🥰
          </p>
          <p className="text-slate-700">
            Som en ekstra bonus findes der også en pool på tagterrassen – og ja, der har de selvfølgelig også installeret en poollift🥹 Udsigten deroppe er helt fantastisk! Her kan man nyde udsigten over poolområderne og helt ud til havet, mens man sidder med en drink fra tagbaren🍹 Det er virkelig et sted, hvor man får lyst til bare at blive siddende🌞
          </p>
        </div>

        <p>
          Jeg boede selv i en almindelig suite i stueplan, og det er uden tvivl et af de fineste hotelværelser, jeg har boet på! Terrassen lå ud mod poolområdet, men var samtidig dejligt afskærmet, så man kunne sidde helt privat🌴
          Eneste minus kan være at alt efter hvor man får værelse, er der 5 min gang til enten reception eller restaurant, da hotellet er forholdsvis stort, uden det derudover føles stort, i og med der er flere poolområder🙏🏼
        </p>

        <p>
          Hotellet ligger kun omkring fem minutters gang fra stranden, og fortovene har gode nedkørsler, så det er nemt at komme frem med kørestol🤗 Længere henne ad stranden finder man den handicapvenlige strand med strandkørestole, assistance og handicaptoilet.
        </p>

        <p>
          Maden fortjener også ros. Buffeten er måske ikke den største, jeg har oplevet, men udvalget er virkelig godt, og kvaliteten er høj! Der er noget for både børn og voksne, og jeg synes, det hele virkede frisk og indbydende😍👩‍🍳
        </p>

        <div className="bg-[#99A18C]/15 border border-[#99A18C]/30 p-6 sm:p-8 rounded-3xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-xl">
            Min konklusion?
          </h4>
          <p className="text-slate-700">
            Grupotel Playa de Palma Suites & Spa overraskede mig på den bedst tænkelige måde! Det er et hotel, der har formået at kombinere høj komfort, god tilgængelighed, en fantastisk atmosfære og et personale, der virkelig brænder for at give gæsterne en god oplevelse🤗
          </p>
          <p className="text-slate-900 font-bold italic pt-2">
            Det er uden tvivl et hotel, som jeg med stor glæde vil anbefale til mine kunder – og et sted, jeg selv meget gerne vender tilbage til. ❤️
          </p>
        </div>

        {/* Billede i bunden */}
        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/74f1da8e-d5fd-49ed-bed5-ca5022a89a3e.jpeg"
              alt="Grupotel Playa de Palma Suites & Spa"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">Se flere detaljer for Grupotel Playa de Palma Suites & Spa</p>
              <p className="text-xs text-slate-500">Se suiter, wellness, priser og tilgængelighed</p>
            </div>
            <Link
              to="/da/hotel/grupotel-playa-palma"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>Gå til hotelsiden</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-zoetry-mallorca',
    hotelId: 'zoetry-mallorca',
    title: '✨ Hotelinspektion – Zoëtry Mallorca ✨',
    date: 'juli 2025',
    category: 'Hotelinspektioner',
    categories: ['Hotelinspektioner', 'Handicaprejser', 'Destinationer', 'Praktisk info'],
    intro: 'Zoëtry Mallorca på den historiske herregård Sa Torre skuffede ikke! Her får du magisk ro, plane stier, poollift ved begge pools, rampe i familiepoolen og luksus uden at det bliver stift.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/ceef4750-2ca2-43c1-b82b-e06ba062b589.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/ceef4750-2ca2-43c1-b82b-e06ba062b589.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejsers personlige hotelinspektion</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Zoëtry Mallorca Wellness & Spa</strong> • Område: Llucmajor / Sa Torre, Mallorca • Inspiceret personligt af Alora Rejser
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Nogle hoteller ser fantastiske ud på billeder. Men nogle gange er virkeligheden bare ikke helt den samme🙉
        </p>

        <p>
          Da jeg første gang faldt over Zoëtry Mallorca, tænkte jeg: “Hvis bare det sted er halvt så magisk i virkeligheden, som det ser ud på billederne…” Derfor var det et hotel, jeg bare måtte besøge på min inspektionstur🤗 Og hold op… det skuffede ikke! !
        </p>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-lg">
            Historiske rammer og magisk ro på herregården Sa Torre 🏰🌿
          </h4>
          <p className="text-slate-700">
            Zoëtry Mallorca ligger på den historiske herregård Sa Torre, hvor historien går helt tilbage til 1300-tallet. De gamle stenbygninger, den smukke herregård, kapellet, de store gamle træer og de hyggelige gårdmiljøer giver en stemning, som er meget svær at beskrive😍
          </p>
          <p className="text-slate-700">
            Man føler næsten, man er rejst flere hundrede år tilbage i tiden – bare med al den luksus og komfort, man kan ønske sig😎
          </p>
          <p className="text-slate-700">
            Det, der overraskede mig mest, var roen. Selvom hotellet er stort, er der masser af små hyggelige kroge med bænke i skyggen, gamle træer og grønne områder, hvor man bare har lyst til at sætte sig og nyde omgivelserne, læse en bog eller suge roen ind!
          </p>
          <p className="text-slate-700">
            Rundt på hele området er der lange, plane stier, som gør det nemt at komme rundt – også i kørestol. Der er endda tennisbane, hvis man har lyst til at være aktiv🎾
          </p>
        </div>

        <div className="bg-emerald-50 border border-emerald-200/80 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-emerald-950 text-lg">
            Undersøgelse af tilgængeligheden ♿
          </h4>
          <p className="text-slate-700">
            Som altid brugte jeg god tid på at undersøge tilgængeligheden!
          </p>
          <p className="text-slate-700">
            Der er enkelte steder med lidt ujævn belægning – blandt andet ved receptionen og ved den ene restaurant, men ikke noget en manuel eller elektrisk stol ikke kan klare🙏🏼
          </p>
          <p className="text-slate-700">
            Ved første øjekast ser det ud, som om restauranten kun kan nås via trapper, men personalet åbner gerne de to porte få meter til venstre, så man kan køre direkte ind. Her ligger også et stort rummeligt handicaptoilet. Der er elevator de steder, hvor det er nødvendigt – blandt andet ned til spaområdet😊
          </p>
          <p className="text-slate-700">
            Poolområdet gjorde mig virkelig glad! Begge pools har <strong>poollift</strong>, og familiepoolen har desuden en <strong>rampe ned i vandet</strong>. Det giver en fleksibilitet, som mange af mine kunder vil sætte stor pris på! Udover det var der bar med caféborde/servering ved relax poolen og begge pools lå i magiske omgivelser!
          </p>
          <p className="text-slate-700">
            Handicapværelserne var præcis, som jeg håbede. Store, lyse og med virkelig rummelige badeværelser. Der er god plads omkring toilettet, roll-in shower og generelt rigtig fine adgangsforhold. Den eneste lille detalje, jeg bemærkede, var, at armaturet til vandet sidder lidt væk fra badestolen – men efter min vurdering fungerer det stadig. Der er en super hyggelig terrasse, dog med en lille kant ud til men gode brede dobbeltdøre ud til🙏🏼
          </p>
        </div>

        <p>
          En anden ting, jeg virkelig elsker ved Zoëtry Mallorca, er følelsen af luksus uden, at det bliver stift. Man føler sig velkommen og forkælet, men samtidig føler man sig utrolig hjemme. Det er en sjælden kombination!
        </p>

        <p className="text-sm text-slate-600 italic">
          Hotellet ligger cirka 15 minutters kørsel fra Palma Lufthavn og omkring 20 minutter fra Palma by, så jeg vil klart anbefale en lejebil eller være indstillet på at tage en taxi 🚖
        </p>

        <div className="bg-[#99A18C]/15 border border-[#99A18C]/30 p-6 sm:p-8 rounded-3xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-xl">
            ❤️ Min personlige vurdering?
          </h4>
          <p className="text-slate-700">
            Jeg ville sende mine egne kunder hertil uden at tøve!
            Det er et af de steder, hvor billederne faktisk ikke yder hotellet retfærdighed. Stemningen, roen og de historiske omgivelser skal opleves❤️
          </p>
          <p className="text-slate-700">
            Det er præcis derfor, jeg tager ud og besøger hotellerne selv. Ikke for at kunne sige, at jeg har været der – men for at kunne fortælle mine kunder, hvordan stedet føles, og om jeg med ro i maven kan anbefale det🙏🏼
          </p>
          <p className="text-slate-900 font-bold italic pt-2">
            Og Zoëtry Mallorca er uden tvivl et sted, jeg glæder mig til at sende mange gæster til. 🤍
          </p>
        </div>

        {/* Billede i bunden */}
        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/ceef4750-2ca2-43c1-b82b-e06ba062b589.jpeg"
              alt="Zoëtry Mallorca Wellness & Spa"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">Se flere detaljer for Zoëtry Mallorca Wellness & Spa</p>
              <p className="text-xs text-slate-500">Se suiter, spa, tilgængelig golf og luksusfaciliteter</p>
            </div>
            <Link
              to="/da/hotel/zoetry-mallorca"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>Gå til hotelsiden</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-forum-boutique-hotel-spa',
    hotelId: 'forum-boutique-hotel-spa',
    title: '⭐ Hotelinspektion – Forum Boutique Hotel & Spa, Alcúdia 🌿',
    date: 'oktober 2025',
    category: 'Hotelinspektioner',
    categories: ['Hotelinspektioner', 'Handicaprejser', 'Destinationer', 'Praktisk info'],
    intro: 'Et lille, eksklusivt boutiquehotel med en helt særlig familiefølelse – midt i hjertet af Alcúdias gamle bydel❤️ Forum Boutique Hotel & Spa er et af de hoteller, der virkelig gjorde indtryk på mig. Et lille Adults Only (+18) boutiquehotel med kun 16 værelser.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/img-2260.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/img-2260.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejsers personlige hotelinspektion</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Forum Boutique Hotel & Spa</strong> • Område: Alcúdia (Gamle bydel), Mallorca • Inspiceret personligt af Alora Rejser
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Et lille, eksklusivt boutiquehotel med en helt særlig familiefølelse – midt i hjertet af Alcúdias gamle bydel❤️
        </p>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Forum Boutique Hotel & Spa er et af de hoteller, der virkelig gjorde indtryk på mig.
        </p>

        <p>
          Hotellet er et lille Adults Only (+18) boutiquehotel med kun 16 værelser, og allerede når man træder indenfor, mærker man, at det ikke er et traditionelt stort feriehotel. Her er personligt, roligt og utrolig hyggeligt☀️
        </p>

        <div className="bg-amber-50/60 border border-amber-200/80 p-5 rounded-2xl space-y-3">
          <p className="font-medium text-amber-950">
            Noget af det, jeg især lagde mærke til under mit besøg, var den helt særlige familiefølelse.
          </p>
          <p className="text-amber-900">
            Personalet er simpelthen så venligt, imødekommende og hjælpsomme🙏🏼
          </p>
          <p className="text-amber-900">
            Man mærker virkelig, at de gerne vil deres gæster, og at de vil gøre rigtig meget for, at opholdet fungerer bedst muligt🥰
          </p>
          <p className="text-amber-950 font-semibold">
            Det er den slags hotel, hvor man føler sig set👀
          </p>
        </div>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🌿 Et gennemført og eksklusivt lille hotel</span>
          </h4>
          <p>
            Forum ligger i en smukt restaureret historisk bygning fra omkring slutningen af 1500-tallet/begyndelsen af 1600-tallet🏰
          </p>
          <p>
            Det gamle Mallorca er bevaret med blandt andet stenmure, buer og smukke historiske detaljer, samtidig med at hotellet er blevet moderniseret.
          </p>
          <p className="font-medium text-slate-900">
            Og det er virkelig gennemført!
          </p>
          <p>
            Værelser, fællesområder, gårdhave og hotellets øvrige rum hænger utrolig fint sammen, så man får følelsen af ét samlet lille mallorcinsk hjem fremfor et traditionelt hotel🤗
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
            <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00001_44553955.jpeg"
                alt="Forum Boutique Hotel indgang"
                className="w-full h-48 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-white">Indgang med historisk stenfacade og krukkeplanter</p>
            </div>
            <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00016_04a23503.jpeg"
                alt="Forum Boutique Hotel reception og stenmure"
                className="w-full h-48 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-white">Stemningsfuld lobby med rå stenmure og historiske buer</p>
            </div>
          </div>
        </div>

        <div className="bg-emerald-50 border border-emerald-200/80 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-emerald-950 text-lg flex items-center gap-2">
            <span>♿ Det handicapvenlige værelse</span>
          </h4>
          <p className="text-emerald-900">
            Det handicapvenlige værelse ligger i stueplan, og det er efter min mening et af hotellets allerhyggeligste værelser.
          </p>
          <p className="text-emerald-900 font-medium">
            Her får man virkelig den mallorcinske stemning😍
          </p>
          <p className="text-emerald-900">
            Værelset er rummeligt med rigtig god plads omkring sengen, og indretningen passer smukt sammen med resten af hotellet.
          </p>
          <p className="text-emerald-900">
            Der er mulighed for at få badestol gennem hotellet, og for gæster, der har behov for ekstra støtte ved toilettet, kan Alora Rejser sørge for bestilling af dette🤩
          </p>
          <p className="text-emerald-950 font-semibold bg-white/70 p-3.5 rounded-xl border border-emerald-200">
            Det betyder, at vi kan tilpasse opholdet mere til den enkelte gæsts behov🤗
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
            <div className="rounded-xl overflow-hidden border border-emerald-100 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00004_47e2eb94.jpeg"
                alt="Handicapvenligt værelse med god plads"
                className="w-full h-48 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-white">Rummeligt handicapvenligt værelse i stueplan</p>
            </div>
            <div className="rounded-xl overflow-hidden border border-emerald-100 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00005_ff490f44.jpeg"
                alt="Trinløst badeværelse"
                className="w-full h-48 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-white">Trinløst badeværelse med plads til badestol og toiletstøtter</p>
            </div>
          </div>
        </div>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🏊 Den lille gårdhave og pool</span>
          </h4>
          <p>
            Midt i hotellet finder man den skønneste lille gårdhave med en mindre pool.
          </p>
          <p>
            Det er ikke en stor resortpool – og det skal den heller ikke være😊
          </p>
          <p className="font-medium text-slate-900">
            Her handler det om atmosfære, ro og charme🌸
          </p>
          <div className="p-4 bg-amber-50/90 rounded-xl border border-amber-300 text-amber-950 space-y-2">
            <div className="flex items-center gap-2 font-bold text-amber-900">
              <AlertCircle className="w-5 h-5 text-amber-700 shrink-0" />
              <span>Vigtigt omkring tilgængeligheden: Poolen har hverken poollift eller rampe.!</span>
            </div>
            <p className="text-xs sm:text-sm text-amber-900 leading-relaxed">
              Den er derfor bedst egnet til den selvhjulpne gæst, som eksempelvis selv kan komme ned og sidde på kanten og derfra komme i vandet, eller dig som kan gå ned med støtte og hjælp fra gelænderet.
            </p>
            <p className="text-xs sm:text-sm text-amber-900 font-medium">
              For en kørestolsbruger uden denne mulighed vil poolen desværre ikke være tilgængelig.
            </p>
          </div>
          <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs pt-1">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00008_0d5d2247.jpeg"
              alt="Den lille gårdhave og pool"
              className="w-full h-56 object-cover"
            />
            <p className="text-[11px] text-slate-500 p-2 bg-white">Den charmerende gårdhave med lille pool og romertrappe med gelænder</p>
          </div>
        </div>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🧖‍♀️ Spa – oplagt til en forlænget weekend</span>
          </h4>
          <p>
            Man skal samtidig huske, at Forum også er et spa-hotel, og derfor synes jeg faktisk, det er et rigtig interessant valg til eksempelvis en forlænget weekend.
          </p>
          <p>
            Hotellets spa tilbyder blandt andet sauna, dampbad, fodbad, sansedusche og hydromassage. Derudover kan der bestilles terapeutiske massager😍
          </p>
          <p>
            Derfor behøver den manglende adgang til den lille udendørs pool ikke nødvendigvis være afgørende.
          </p>
          <p className="font-medium text-slate-900">
            Man kan sagtens vælge Forum for den gamle by, atmosfæren, spaoplevelsen, maden i området og en hyggelig weekend væk hjemmefra🤩
          </p>
          <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00011_a8e851d6.png"
              alt="Hotellets spaområde"
              className="w-full h-56 object-cover"
            />
            <p className="text-[11px] text-slate-500 p-2 bg-white">Wellness og spa med sauna, hydromassage og afslappende rammer</p>
          </div>
        </div>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>☕ Morgenmad</span>
          </h4>
          <p>
            Opholdet inkluderer en kontinental morgenmad med traditionelle lokale mad/drikkevare, som serveres fra kl. 8.00–10.30.
          </p>
          <p>
            Hotellet har ikke en traditionel restaurant til frokost og aftensmad, men det er næsten svært at se som en ulempe her😌
          </p>
          <p className="font-medium text-slate-900">
            For når man træder ud af døren, befinder man sig midt i et af de hyggeligste områder i Alcúdia.
          </p>
        </div>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>❤️ Placeringen er noget helt særligt</span>
          </h4>
          <p>
            Forum ligger lige i hjertet af Alcúdias gamle bydel.
          </p>
          <p>
            Går du ud af hotellet og rundt om hjørnet, kommer du næsten direkte til et stort og stemningsfuldt torv med restauranter og udeservering🍛🥘👩‍🍳
          </p>
          <p>
            Drejer du til venstre fra hotellet, finder du små butikker – og en virkelig lækker iskiosk😋
          </p>
          <p>
            Går du ganske få skridt i den modsatte retning, kommer du til et lidt mere gemt og utrolig hyggeligt torv placeret under træerne. Her ligger et par restauranter, og på den ene kan man få nogle helt fantastiske pizzaer 🍕
          </p>
          <p className="font-medium text-slate-900">
            Og sådan fortsætter det egentlig…
          </p>
          <p>
            Små gader, gamle huse, hyggelige restauranter, caféer, butikker og små pladser ligger omkring hotellet.
          </p>
          <p className="font-semibold text-emerald-900 bg-emerald-50/60 p-3.5 rounded-xl border border-emerald-100">
            Man behøver derfor ikke en bil for at få en hyggelig ferie her.
          </p>
        </div>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🚌 Strand og transport</span>
          </h4>
          <p>
            Vil man have en rigtig stranddag, ligger Alcúdias lange sandstrand omkring 2½ km væk.
          </p>
          <p>
            For nogle vil turen kunne klares til fods eller i kørestol afhængigt af mobilitet og hjælp, men der er også en rigtig god mulighed med offentlig transport.
          </p>
          <p>
            Omkring fem minutters vej fra hotellet ligger Alcúdias store busstation, hvorfra der kører busser mod blandt andet strandområdet. Busserne er velegnede til kørestolsbrugere, og der er gode forbindelser gennem dagen og også om aftenen🚌
          </p>
          <p className="font-medium text-slate-900">
            Ved den tilgængelige del af stranden er der i badesæsonen mulighed for hjælp til at komme i vandet med amfibiestol🏖️⛱️☀️
          </p>
        </div>

        <div className="bg-emerald-50/70 border border-emerald-200 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-emerald-950 text-lg flex items-center gap-2">
            <span>🌊 En tur til Port de Pollença</span>
          </h4>
          <p className="text-emerald-950">
            Vil man opleve lidt mere, ligger Port de Pollença cirka 10 km væk.
          </p>
          <p className="text-emerald-950">
            Det er et af mine favoritområder på Mallorca med strandpromenade, restauranter, butikker og masser af liv, men mere rolig end alcudia🙏🏼
          </p>
          <p className="text-emerald-950">
            Her har Alora Rejser også hoteller – blandt andet <Link to="/da/hotel/puerto-azul-suite-hotel" className="font-bold underline text-emerald-900 hover:text-emerald-700">Puerto Azul Suite Hotel</Link>.
          </p>
          <p className="text-emerald-950">
            Det kan være en god mulighed for gæster på Forum, hvis man ønsker en dag ved en pool med poollift, da Puerto Azul giver mulighed for, at gæster udefra kan købe et dagskort til deres poolområde.
          </p>
          <p className="text-emerald-950 font-semibold bg-white/80 p-4 rounded-xl border border-emerald-200">
            Dermed kan man kombinere det lille, eksklusive boutiquehotel og stemningen i Alcúdias gamle by med en dag ved en mere tilgængelig pool🏊🏼‍♂️☀️
          </p>

          <div className="p-4 bg-white rounded-xl border border-emerald-200 flex flex-col sm:flex-row items-center justify-between gap-3 shadow-xs mt-2">
            <div>
              <p className="font-bold text-slate-900 text-sm">Puerto Azul Suite Hotel i Port de Pollença</p>
              <p className="text-xs text-slate-600">Se det familievenlige hotel med stor pool og poollift kun 90 m fra stranden</p>
            </div>
            <Link
              to="/da/hotel/puerto-azul-suite-hotel"
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-emerald-700 hover:bg-emerald-800 text-white text-xs font-bold rounded-lg transition-all shrink-0 shadow-2xs"
            >
              <span>Se Puerto Azul</span>
              <ArrowRight size={13} />
            </Link>
          </div>
        </div>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🌿 Min vurdering</span>
          </h4>
          <p>
            Forum Boutique Hotel & Spa er ikke hotellet for alle kørestolsbrugere, og det er vigtigt for mig at være ærlig omkring det.
          </p>
          <p className="font-medium text-slate-900">
            Poolen har ikke lift eller rampe, og derfor skal man vælge hotellet ud fra sine egne behov og sin mobilitet. Men det er fuldstændig niveaufri overalt 🙏🏼
          </p>
          <p>
            Men for den selvhjulpne kørestolsbruger eller gangbesværede, som ønsker noget andet end de store traditionelle handicapvenlige resorts, synes jeg, Forum er et fantastisk lille fund🤩
          </p>
          <p>
            Forum er for mig et eksempel på, at en handicapvenlig ferie ikke nødvendigvis behøver foregå på et stort resort.
          </p>
          <p className="font-medium text-slate-900">
            Nogle gange vil man bare gerne bo et lille, smukt og eksklusivt sted, gå ud ad døren om aftenen og være midt i de små mallorcinske gader – spise godt, få et glas vin på torvet, nyde en spa-behandling og føle, at man faktisk er på Mallorca.
          </p>
          <p className="font-semibold text-emerald-900 bg-emerald-50/80 p-4 rounded-xl border border-emerald-100 text-base">
            Det er præcis den følelse, Forum giver. 💚
          </p>
        </div>

        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/img-2260.jpeg"
              alt="Forum Boutique Hotel og gårdhave"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">Se hele hotelsiden for Forum Boutique Hotel & Spa</p>
              <p className="text-xs text-slate-500">Se priser, faciliteter, galleri og indhent uforpligtende tilbud</p>
            </div>
            <Link
              to="/da/hotel/forum-boutique-hotel-spa"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>Gå til hotelsiden</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-quartier-libre-marais',
    hotelId: 'quartier-libre-marais',
    title: '⭐ Hotelinspektion – Quartier Libre Marais, Paris ⭐️',
    date: 'august 2025',
    category: 'Hotelinspektioner',
    categories: ['Hotelinspektioner', 'Handicaprejser', 'Destinationer', 'Praktisk info'],
    intro: 'Quartier Libre Marais er et charmerende fund til en tilgængelig storbyferie i Paris. Bo midt i det ægte Paris tæt på Notre-Dame, handicapvenlig RER-station og hyggelige caféer.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/64fd0157-b6d3-4a32-92d8-543580f708a8.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/64fd0157-b6d3-4a32-92d8-543580f708a8.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejsers personlige hotelinspektion</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Quartier Libre Marais</strong> • Område: Marais, Paris, Frankrig • Inspiceret personligt af Alora Rejser
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Quartier Libre Marais er et af de hoteller, hvor man allerede ved ankomsten mærker, at man er landet midt i Paris😍
        </p>

        <p>
          Hotellet er lille, utrolig charmerende og ligger i et skønt område med ægte parisisk stemning. Man træder ind gennem den fineste blå dør, og både hotellet og området har den hyggelige, lokale atmosfære, som jeg personligt synes gør en storbyferie noget helt særligt🥹
        </p>

        <p>
          Lige uden for døren finder man små lokale butikker, bager, slagter, pizzeriaer, caféer og supermarkeder, så man har stort set alt, hvad man behøver, tæt på🙏🏼
          Samtidig bor man virkelig centralt. <strong>Notre-Dame ligger omkring 20 minutters gang fra hotellet</strong>, så mange af Paris’ oplevelser kan nås til fods eller på hjul direkte fra hotellet👨🏽‍🦽
        </p>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-lg">
            Fremragende udgangspunkt for at opleve Paris ⭐️🚇
          </h4>
          <p className="text-slate-700">
            Cirka 10 minutters gang fra hotellet ligger en handicapvenlig togstation, hvorfra man blandt andet kan komme direkte til Disneyland Paris på omkring 40 minutter😎
          </p>
          <p className="text-slate-700">
            Få minutters gang fra hotellet findes desuden handicapvenlige busser, der kører i forskellige retninger gennem byen. Det giver gode muligheder for at komme rundt og opleve Paris uden nødvendigvis at være afhængig af taxi🚕
          </p>
        </div>

        <div className="bg-sky-50 border border-sky-100 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-sky-950 text-lg">
            Hyggelig, tryg base med fine detaljer 🥐🧺
          </h4>
          <p className="text-slate-700">
            Selve hotellet føles både hyggeligt og trygt🙏🏼 Der er kode for at komme ind på hotellet, så uvedkommende ikke bare kan gå ind, og man bruger ligeledes kode til sin lejlighed. Det er en lille detalje, jeg virkelig godt kan lide – man slipper for at skulle huske en nøgle eller et nøglekort, når man er ude hele dagen🤗
          </p>
          <p className="text-slate-700">
            Lejligheden er rigtig fint indrettet og har et lille køkken, så man selv kan lave morgenmad eller et let måltid.
            Ønsker man hellere at spise morgenmad på hotellet, serveres der en rigtig lækker morgenmad med blandt andet de klassiske franske croissanter 🥐
            En ekstra hyggelig detalje er, at de croissanter, der er tilovers efter morgenmaden, bliver lagt frem, så gæsterne frit kan tage en i løbet af dagen😋
          </p>
          <p className="text-slate-700">
            I lejligheden er der også et lille spisebord, hvor man kan sidde og kigge ud på den hyggelige parisiske gade. Det er netop sådan nogle detaljer, der gør, at man ikke bare føler, man bor på et hotel, men nærmest har sin egen lille base midt i Paris😍
          </p>
          <p className="text-slate-700 font-semibold">
            En rigtig praktisk detalje – især på en lidt længere storbyferie – er, at hotellet har <strong>gratis vaskefaciliteter</strong>. Man kan gå ned i kælderen og vaske sit tøj ved behov, hvilket er en rigtig fin ekstra service🧺
          </p>
        </div>

        <div className="bg-emerald-50 border border-emerald-200/80 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-emerald-950 text-lg">
            Vigtigt at vide om tilgængeligheden ♿
          </h4>
          <p className="text-slate-700">
            Badeværelset er fint og rummeligt med god plads til kørestol, og der er badestol. Der er desuden mulighed for at bestille ekstra hjælpemidler efter behov. Soveværelset har også en ok fin størrelse og fungerer godt med manuel kørestol, det blir lidt mere klemt ned elektrisk stol.
          </p>
          <div className="bg-amber-50 border border-amber-200 p-4 rounded-xl space-y-2 text-amber-900 text-sm">
            <p className="font-bold flex items-center gap-1 text-amber-950">
              <AlertCircle size={16} />
              Dørbredde og sovesofa:
            </p>
            <p>
              Døren ind til lejligheden er forholdsvis smal, og jeg vil derfor anbefale, at kørestolen <strong>ikke er bredere end cirka 70 cm</strong>. Det er en vigtig detalje at være opmærksom på inden booking.
            </p>
            <p>
              Rejser man flere end to personer og skal benytte sovesofaen, bliver pladsen mere trang. Når sovesofaen er slået helt ud, er der ikke plads til at passere den med kørestol. Derfor skal man være indstillet på at slå sofaen sammen om morgenen og ud igen om aftenen. For to personer oplevede jeg derimod lejligheden som rigtig anvendelig⭐️
            </p>
          </div>
        </div>

        <div className="bg-[#99A18C]/15 border border-[#99A18C]/30 p-6 sm:p-8 rounded-3xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-xl">
            Aloras vurdering
          </h4>
          <p className="text-slate-700">
            For mig er Quartier Libre Marais især et godt valg til den kørestolsbruger, der gerne vil opleve <strong>det rigtige Paris</strong> og samtidig have en hyggelig og praktisk base🌸
          </p>
          <p className="text-slate-700">
            Det er ikke et stort, klassisk turisthotel med masser af faciliteter – og det er faktisk en stor del af charmen. Her bor man midt blandt lokale butikker og franske specialforretninger og kan starte dagen med en croissant, kigge ud på gaden og mærke storbyen lige uden for døren🇫🇷
          </p>
          <p className="text-slate-900 font-bold italic pt-2">
            Jeg synes, Quartier Libre Marais er et virkelig charmerende fund til en tilgængelig storbyferie i Paris – især fordi kombinationen af den hyggelige lejlighed, den centrale beliggenhed og mulighederne for handicapvenlig offentlig transport gør det nemt at komme ud og opleve byen🙏🏼❤️
          </p>
        </div>

        {/* Billede i bunden */}
        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/64fd0157-b6d3-4a32-92d8-543580f708a8.jpeg"
              alt="Quartier Libre Marais"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">Se flere detaljer for Quartier Libre Marais</p>
              <p className="text-xs text-slate-500">Se lejligheder, faciliteter, priser og beliggenhed i Paris</p>
            </div>
            <Link
              to="/da/hotel/quartier-libre-marais"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>Gå til hotelsiden</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-puerto-azul-suite-hotel',
    hotelId: 'puerto-azul-suite-hotel',
    title: '⭐ Hotelinspektion – Puerto Azul Suite Hotel, Port de Pollença ⭐⭐⭐⭐',
    date: 'juli 2025',
    category: 'Hotelinspektioner',
    categories: ['Hotelinspektioner', 'Handicaprejser', 'Destinationer', 'Praktisk info'],
    intro: 'Puerto Azul Suite Hotel er et af de hoteller, hvor jeg virkelig oplever, at tilgængelighed er tænkt ind i hele hotellet – og ikke kun på det handicapvenlige værelse🙏🏼 Læs vores personlige inspektion af det rolige resort tæt på Pine Walk, poolliften og den rummelige suite.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00001_6b74cabc.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00001_6b74cabc.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejsers personlige hotelinspektion</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Puerto Azul Suite Hotel</strong> • Område: Port de Pollença, Mallorca • Inspiceret personligt af Alora Rejser
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Puerto Azul Suite Hotel er et af de hoteller, hvor jeg virkelig oplever, at tilgængelighed er tænkt ind i hele hotellet – og ikke kun på det handicapvenlige værelse🙏🏼
        </p>

        {/* 🌿 Et roligt og overskueligt resort */}
        <div className="bg-stone-50 border border-stone-200/80 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🌿 Et roligt og overskueligt resort</span>
          </h4>
          <p>
            Selvom Puerto Azul har en stor buffetrestaurant og et dejligt stort poolområde, oplevede jeg alligevel hotellet som overraskende roligt og overskueligt, midt i juli mdr 🤗
          </p>
          <p>
            Det føles ikke som et kæmpe resort, hvor der konstant er larm og tusind ting omkring én. Tværtimod synes jeg, at det har en rigtig behagelig atmosfære, hvor man både kan være familie/par og bare nyde en afslappende ferie⛱️❤️
          </p>
        </div>

        {/* ♿ Her er tilgængeligheden virkelig tænkt ind */}
        <div className="bg-emerald-50 border border-emerald-200/80 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-emerald-950 text-lg flex items-center gap-2">
            <span>♿ Her er tilgængeligheden virkelig tænkt ind</span>
          </h4>
          <p className="text-slate-700">
            Noget af det, der gjorde størst indtryk på mig under min inspektion, var, hvor lydhøre Puerto Azul er over for gæster med handicap og nedsat mobilitet🙏🏼
          </p>
          <p className="text-slate-700">
            De har virkelig gjort, hvad de kan for at tænke tilgængelighed ind i hotellets dagligdag og i måden, man bevæger sig rundt på resortet!
          </p>
          <p className="text-slate-700">
            Og det gælder ikke kun de mest oplagte steder som receptionen, restauranten og poolområdet.
          </p>
          <p className="text-slate-700">
            Når familien eksempelvis bevæger sig ned mod området med bordtennis eller børnenes legeområde, er der også tænkt på adgangen.
          </p>
          <div className="bg-white/80 border border-emerald-300 p-4 rounded-xl space-y-2">
            <p className="font-bold text-emerald-900">
              Det betyder meget for mig!
            </p>
            <p className="text-emerald-950 italic text-sm">
              For ferie handler også om, at alle kan være med. Et barn eller en voksen i kørestol skal ikke blive siddende tilbage, fordi resten af familien bevæger sig hen til et område, der ikke er tilgængeligt🥺
            </p>
          </div>
          <p className="text-slate-700">
            Ramperne er efter min vurdering rigtig gode. De er brede, fine at køre på og føles ikke unødigt stejle. Derfor synes jeg hotellet fungerer rigtig godt, både for kørestolsbrugere og gangbesværede.
          </p>
        </div>

        {/* 🛏️ Den handicapvenlige suite */}
        <div className="space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🛏️ Den handicapvenlige suite</span>
          </h4>
          <p>
            Den handicapvenlige suite er rummelig og rigtig godt indrettet🤗
          </p>
          <p>
            Der er separat soveværelse og opholdsafdeling, og man kommer helt niveaufrit ud på terrassen, som er superhyggelig og har god plads til en kørestol🌸
          </p>
          <p>
            Hotellets suiter kan generelt rumme op til 4 personer. Ved booking af den handicapvenlige suite tjekker jeg dog altid den konkrete belægning med hotellet, så vi er sikre på, at værelset passer til den enkelte familie.
          </p>
          <p>
            Der er ikke mulighed for at lave mad på værelset.
          </p>
          <p>
            Til gengæld er der en lille praktisk afdeling med køleskab og mulighed for at lave kaffe og te, og der er et lille bord med fire siddepladser, til hygge eller hvis man ønsker takeaway el lign🥰
          </p>
          <p>
            Og har man ikke lyst til selv at stå for noget, er hotellets store buffetrestaurant naturligvis lige ved hånden👩‍🍳
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
            <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00041_d13d5009.png"
                alt="Puerto Azul Suite Hotel handicapvenlig suite soveværelse"
                className="w-full h-48 sm:h-56 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-stone-50 text-center">Den rummelige suite med soveafdeling og lille spisebord</p>
            </div>
            <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00007_1b62b57d.jpeg"
                alt="Puerto Azul Suite Hotel niveaufrit terrasse"
                className="w-full h-48 sm:h-56 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-stone-50 text-center">Niveaufri adgang til den private terrasse med bord og stole</p>
            </div>
          </div>
        </div>

        {/* 🚿 Et virkelig godt handicapbadeværelse */}
        <div className="bg-emerald-50/60 border border-emerald-200/80 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🚿 Et virkelig godt handicapbadeværelse</span>
          </h4>
          <p>
            Badeværelset er efter min vurdering et af de helt store plusser ved Puerto Azul🤩
          </p>
          <p>
            Det er et af de større handicapbadeværelser, jeg har set.
          </p>
          <p>
            Der er rigtig god plads til at manøvrere med kørestol, og der er plads, hvis man har behov for eksempelvis badekørestol.
          </p>
          <div className="bg-white/80 border border-emerald-300 p-4 rounded-xl space-y-2">
            <p className="font-bold text-emerald-900">
              Og så har de en lille detalje, som jeg faktisk meget sjældent ser:
            </p>
            <p className="text-slate-800">
              <strong>Der er rygstøtte/pude ved toilettet.</strong>
            </p>
            <p className="text-xs text-slate-600">
              For nogle gæster kan det gøre en stor forskel, og det er endnu et eksempel på, at hotellet faktisk har tænkt over de praktiske behov.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-1">
            <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00010_ba448f08.jpeg"
                alt="Puerto Azul handicapbadeværelse med underkørbar vask og bruseniche"
                className="w-full h-48 sm:h-56 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-stone-50 text-center">Rummeligt badeværelse med underkørbar vask, armstøtter og opklappeligt badesæde</p>
            </div>
            <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00009_9ba9a516.jpeg"
                alt="Toilettet med rygstøtte og armstøtter på Puerto Azul"
                className="w-full h-48 sm:h-56 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-stone-50 text-center">Toilettet med armstøtter og den særlige rygstøtte/pude</p>
            </div>
          </div>
        </div>

        {/* 🏊 Poolområdet – med én vigtig begrænsning */}
        <div className="space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🏊 Poolområdet – med én vigtig begrænsning</span>
          </h4>
          <p>
            Hotellet har et dejligt stort poolområde med voksenpool og separat område til børn.
          </p>
          <p>
            Der er poollift, så kørestolsbrugere og gæster med nedsat mobilitet har mulighed for at komme ned i vandet☀️
          </p>

          <div className="bg-amber-50 border border-amber-200 p-4 rounded-xl space-y-2 text-amber-900 text-sm">
            <p className="font-bold flex items-center gap-1.5 text-amber-950">
              <AlertCircle size={17} className="text-amber-700 shrink-0" />
              Men her er også den væsentligste ulempe ved hotellet:
            </p>
            <p className="font-semibold text-amber-950">
              Der er ikke rampe ned i poolen.
            </p>
            <p>
              Hvis man er afhængig af eller foretrækker en poolrampe frem for poollift, skal man derfor være opmærksom på dette!
            </p>
          </div>

          <p>
            Selve området omkring poolen er til gengæld rigtig fint tilgængeligt.
          </p>

          <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00003_4cf773dc.jpeg"
              alt="Puerto Azul poolområde med palmer og liggestole"
              className="w-full h-56 sm:h-72 object-cover"
            />
            <p className="text-[11px] text-slate-500 p-2 bg-stone-50 text-center">Det indbydende poolområde med palmer og god plads omkring bassinet</p>
          </div>
        </div>

        {/* 🍴 Restaurant og livet på hotellet🤗 */}
        <div className="bg-stone-50 border border-stone-200/80 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🍴 Restaurant og livet på hotellet🤗</span>
          </h4>
          <p>
            Puerto Azul har en stor buffetrestaurant med blandt andet show cooking og et godt udvalg af forskellige retter😋🥘
          </p>
          <p>
            Ved poolområdet findes desuden snackbar, og hotellet tilbyder forskellige aktiviteter for både børn og voksne.
          </p>
          <p>
            Der er blandt andet legeplads, MiniClub, fitness og forskellige aktiviteter og underholdning☀️
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
            <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00052_1552a201.jpeg"
                alt="Puerto Azul buffetrestaurant"
                className="w-full h-44 sm:h-48 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-white text-center">Den lyse buffetrestaurant med god plads mellem bordene</p>
            </div>
            <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00004_eb4214e8.jpeg"
                alt="Puerto Azul snackbar ved poolområdet"
                className="w-full h-44 sm:h-48 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-white text-center">Hotellets hyggelige snack- og poolbar med terrassepladser</p>
            </div>
          </div>
        </div>

        {/* 🌴 Beliggenheden er et kæmpe plus */}
        <div className="space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🌴 Beliggenheden er et kæmpe plus</span>
          </h4>
          <p className="text-slate-900 font-medium">
            Og så kommer vi til noget af det, jeg virkelig elsker ved Puerto Azul:
          </p>
          <p className="text-xl font-bold text-slate-900">
            Beliggenheden! !
          </p>
          <p>
            Hotellet ligger simpelthen i smørhullet af Port de Pollença😍
          </p>
          <p>
            Man skal stort set bare ud af døren og en blok ned, og så er man ved Pine Walk, stranden og alt livet langs vandet.
          </p>
          <p>
            Men husk at kigge til siderne på vej derned👀
          </p>
          <p>
            For noget af det hyggeligste ved Port de Pollença er alle de små steder, man næsten kan komme til at gå forbi😌
          </p>
          <p>
            Der ligger restauranter gemt i små gårdhaver og passager, og byen har masser af små skjulte skatte. Det er en del af den charme, jeg personligt synes gør Port de Pollença til noget helt særligt🤩
          </p>
          <p>
            Der ligger samtidig flere små lokale supermarkeder tæt omkring hotellet😊
          </p>
          <p>
            Blandt andet ligger der en SPAR lige i området bag hotellet, hvor man kan få stort set alt det, man har brug for på ferien. Den butik, jeg besøgte, havde også rampe og var mulig at komme rundt i med kørestol🙏🏼
          </p>
          <p className="font-medium text-slate-900">
            Så man har strand, Pine Walk, restauranter, butikker og byliv lige uden for døren – samtidig med at man kan trække sig tilbage til et forholdsvis roligt resort❤️
          </p>
        </div>

        {/* 💚 Min samlede vurdering */}
        <div className="bg-[#99A18C]/15 border border-[#99A18C]/30 p-6 sm:p-8 rounded-3xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-xl flex items-center gap-2">
            <span>💚 Min samlede vurdering</span>
          </h4>
          <p className="text-slate-800 font-semibold text-base sm:text-lg">
            Puerto Azul er et hotel, jeg meget gerne vil sende mine gæster til.
          </p>
          <p className="text-slate-700">
            Det skyldes ikke bare det store handicapbadeværelse, poolliften eller de gode ramper🙏🏼
          </p>
          <p className="text-slate-900 font-medium">
            Det er helheden, der fungerer.
          </p>
          <p className="text-slate-700">
            Jeg oplever et hotel, som oprigtigt har forsøgt at tænke over, hvordan en gæst med handicap eller nedsat mobilitet kan være en del af ferien og bevæge sig rundt sammen med resten af familien🤗
          </p>
          <p className="text-slate-700">
            Samtidig får man et stort poolområde, buffetrestaurant, aktiviteter for både børn og voksne og en virkelig god beliggenhed i Port de Pollença – uden at hotellet føles som et kæmpe og uoverskueligt resort.
          </p>
        </div>

        {/* ⚠️ Værd at vide */}
        <div className="bg-amber-50/70 border border-amber-200/80 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-amber-950 text-lg flex items-center gap-2">
            <span>⚠️ Værd at vide</span>
          </h4>
          <p className="text-amber-900">
            Puerto Azul er et meget populært hotel, og de handicapvenlige suiter er begrænsede.
          </p>
          <p className="text-amber-950 font-medium">
            Derfor vil jeg anbefale, at man er tidligt ude med sin booking, især hvis man ønsker at rejse i skoleferierne eller andre populære uger🙏🏼
          </p>
          <p className="text-slate-800 pt-2 font-medium">
            For mig er Puerto Azul et rigtig godt eksempel på, at et familiehotel godt kan have mange faciliteter og samtidig føles hyggeligt, overskueligt og tilgængeligt.
          </p>
          <p className="text-emerald-950 font-bold text-base sm:text-lg pt-1">
            Ferie skal føles som ferie – for alle ❤️
          </p>
        </div>

        {/* Billede i bunden + link til hotelsiden */}
        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00001_6b74cabc.jpeg"
              alt="Puerto Azul Suite Hotel Port de Pollença"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">Se flere detaljer og faciliteter for Puerto Azul Suite Hotel</p>
              <p className="text-xs text-slate-500">Se værelser, billedgalleri, priser og beliggenhed i Port de Pollença</p>
            </div>
            <Link
              to="/da/hotel/puerto-azul-suite-hotel"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>Gå til hotelsiden</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  }
];

export const inspectionArticles_en = [
  {
    id: 'inspektion-protur-safari-park',
    hotelId: 'protur-safari-park',
    title: '⭐ Hotel Inspection: Protur Safari Park Aparthotel – Sa Coma, Mallorca ⭐️',
    date: 'May 2025',
    category: 'Hotel inspections',
    categories: ['Hotel inspections', 'Accessible travel', 'Destinations', 'Practical info'],
    intro: 'Protur Safari Park is a hotel full of life and holiday atmosphere from morning to night. Read our personal inspection of the large family hotel, pools, and spacious accessible rooms in flat Sa Coma.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/6a685c48-3be8-45bf-88cd-a6f4d4abd52a.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/6a685c48-3be8-45bf-88cd-a6f4d4abd52a.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejser's personal hotel inspection</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Protur Safari Park Aparthotel</strong> • Area: Sa Coma, Mallorca • Personally inspected by Alora Rejser
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Protur Safari Park is a hotel where there is truly life and holiday atmosphere from morning to evening🥳
        </p>

        <p>
          It is a distinct children- and family hotel, and something is happening almost everywhere – in the best way⭐️
        </p>

        <p>
          The hotel is large, stylish and charming, offering both lively pool fun and quiet relaxing corners where you can unwind.
        </p>

        <div className="bg-emerald-50 border border-emerald-200/80 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-emerald-950 text-lg">
            ♿ Accessibility & Family Rooms
          </h4>
          <p className="text-slate-700">
            The accessible rooms are large and spacious with plenty of room to move around in a wheelchair. Great turning space in the bathroom, ramp ready for the sunny balcony, and family rooms accommodating 2 adults and 2 children!
          </p>
        </div>

        {/* Bottom image */}
        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/6a685c48-3be8-45bf-88cd-a6f4d4abd52a.jpeg"
              alt="Protur Safari Park Aparthotel"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">See full hotel page for Protur Safari Park</p>
              <p className="text-xs text-slate-500">View room details, prices, amenities and photos</p>
            </div>
            <Link
              to="/en/hotel/protur-safari-park"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>View hotel page</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-hoposa-daina',
    hotelId: 'hoposa-daina',
    title: '⭐ Hotel Inspection: Hoposa Daina Adults Only – Port de Pollença ⭐️',
    date: 'June 2025',
    category: 'Hotel inspections',
    categories: ['Hotel inspections', 'Accessible travel', 'Destinations'],
    intro: 'Hoposa Daina Adults Only is a 10 out of 10 hotel for adults seeking elegance, exclusivity and the iconic pool built out over the sea by the Pine Walk in Port de Pollença.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/65a6d291-381c-4b22-8b2b-c8d3a31d8f62.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/65a6d291-381c-4b22-8b2b-c8d3a31d8f62.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejser's personal hotel inspection</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Hoposa Daina Adults Only</strong> • Area: Port de Pollença, Mallorca
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Some hotels make you feel right away that here is something special – and that was exactly how I felt about Hoposa Daina😍
        </p>

        <p>
          Classic charm, seafront location, gorgeous pool over the ocean with pool lift, and elegant rooms right on the Pine Walk.
        </p>

        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/65a6d291-381c-4b22-8b2b-c8d3a31d8f62.jpeg"
              alt="Hoposa Daina"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">See full hotel page for Hoposa Daina</p>
              <p className="text-xs text-slate-500">View room details, prices, amenities and photos</p>
            </div>
            <Link
              to="/en/hotel/hoposa-daina"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>View hotel page</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-aparthotel-flora',
    hotelId: 'aparthotel-flora',
    title: '⭐ Hotel Inspection: Aparthotel Flora, Port de Pollença ⭐️',
    date: 'June 2025',
    category: 'Hotel inspections',
    categories: ['Hotel inspections', 'Accessible travel', 'Destinations', 'Practical info'],
    intro: 'Aparthotel Flora is a charming, intimate green oasis in Port de Pollença with cozy paths, pool lift, spacious ground-floor apartments and short distance to Pine Walk.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/0342bc2b-84b7-4476-8fb4-24a297db4802.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/0342bc2b-84b7-4476-8fb4-24a297db4802.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejser's personal hotel inspection</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Aparthotel Flora</strong> • Area: Port de Pollença, Mallorca
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Aparthotel Flora charmed me right away with its intimate garden feel, ground floor accessible apartments, pool lift and prime location in Port de Pollença.
        </p>

        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/0342bc2b-84b7-4476-8fb4-24a297db4802.jpeg"
              alt="Aparthotel Flora"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">See full hotel page for Aparthotel Flora</p>
              <p className="text-xs text-slate-500">View apartment details, prices and amenities</p>
            </div>
            <Link
              to="/en/hotel/aparthotel-flora"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>View hotel page</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-cabot-pollensa-park',
    hotelId: 'cabot-pollensa-park',
    title: '✨ Hotel Inspection: Cabot Pollensa Park Spa, Mallorca ✨',
    date: 'June 2025',
    category: 'Hotel inspections',
    categories: ['Hotel inspections', 'Accessible travel', 'Destinations', 'Practical info'],
    intro: 'Cabot Pollensa Park Spa in Port de Pollença offers warm service, spacious roll-in showers, pool with lift and Roman stairs, family splash zones, and delicious buffets.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/15d24810-470a-4b8c-931c-d98194e78250.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/15d24810-470a-4b8c-931c-d98194e78250.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejser's personal hotel inspection</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Cabot Pollensa Park Spa</strong> • Area: Port de Pollença, Mallorca
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Cabot Pollensa Park Spa is a wonderful family-friendly hotel with helpful staff, pool lift, splash park, and great accessibility close to the beach in Port de Pollença.
        </p>

        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/15d24810-470a-4b8c-931c-d98194e78250.jpeg"
              alt="Cabot Pollensa Park Spa"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">See full hotel page for Cabot Pollensa Park Spa</p>
              <p className="text-xs text-slate-500">View room details, prices and amenities</p>
            </div>
            <Link
              to="/en/hotel/cabot-pollensa-park"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>View hotel page</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-zafiro-mallorca',
    hotelId: 'zafiro-mallorca',
    title: '⭐️ Hotel Inspection: Zafiro Mallorca ⭐️',
    date: 'July 2025',
    category: 'Hotel inspections',
    categories: ['Hotel inspections', 'Accessible travel', 'Destinations', 'Practical info'],
    intro: 'Private Swim Up pool with adapted bathroom! Discover Zafiro Mallorca in Can Picafort – a unique accessible family resort with pirate waterpark and close proximity to an accessible beach.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00018_a11a675b.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00018_a11a675b.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejser's personal hotel inspection</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Zafiro Mallorca</strong> • Area: Can Picafort, Mallorca
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          A truly unique discovery! Private swim-up rooms with accessible bathrooms, pirate waterpark, and great accessibility in Can Picafort.
        </p>

        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00018_a11a675b.jpeg"
              alt="Zafiro Mallorca"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">See full hotel page for Zafiro Mallorca</p>
              <p className="text-xs text-slate-500">View swim-up rooms, prices and photo gallery</p>
            </div>
            <Link
              to="/en/hotel/zafiro-mallorca"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>View hotel page</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-grupotel-playa-palma',
    hotelId: 'grupotel-playa-palma',
    title: '✨ Hotel Inspection: Grupotel Playa de Palma Suites & Spa, Mallorca ✨',
    date: 'July 2025',
    category: 'Hotel inspections',
    categories: ['Hotel inspections', 'Accessible travel', 'Destinations', 'Practical info'],
    intro: 'Grupotel Playa de Palma Suites & Spa exceeded all expectations with its warm service, calm spa atmosphere, pool lifts (including rooftop!), and comfortable accessible suites.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/74f1da8e-d5fd-49ed-bed5-ca5022a89a3e.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/74f1da8e-d5fd-49ed-bed5-ca5022a89a3e.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejser's personal hotel inspection</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Grupotel Playa de Palma Suites & Spa</strong> • Area: Playa de Palma, Mallorca
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          A wonderful hotel combining high comfort, great accessibility, calm spa feeling, and attentive staff.
        </p>

        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/74f1da8e-d5fd-49ed-bed5-ca5022a89a3e.jpeg"
              alt="Grupotel Playa de Palma Suites & Spa"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">See full hotel page for Grupotel Playa de Palma</p>
              <p className="text-xs text-slate-500">View suites, spa facilities, prices and photos</p>
            </div>
            <Link
              to="/en/hotel/grupotel-playa-palma"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>View hotel page</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-zoetry-mallorca',
    hotelId: 'zoetry-mallorca',
    title: '✨ Hotel Inspection: Zoëtry Mallorca ✨',
    date: 'July 2025',
    category: 'Hotel inspections',
    categories: ['Hotel inspections', 'Accessible travel', 'Destinations', 'Practical info'],
    intro: 'Zoëtry Mallorca on the historic estate Sa Torre is truly magical. Peaceful surroundings, flat paths, pool lifts at both pools, water ramp in the family pool and unpretentious luxury.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/ceef4750-2ca2-43c1-b82b-e06ba062b589.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/ceef4750-2ca2-43c1-b82b-e06ba062b589.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejser's personal hotel inspection</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Zoëtry Mallorca Wellness & Spa</strong> • Area: Llucmajor, Mallorca
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          The atmosphere, serenity, and historic beauty of Sa Torre exceeded all expectations. Exceptional accessibility with pool lifts and wide paths.
        </p>

        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/ceef4750-2ca2-43c1-b82b-e06ba062b589.jpeg"
              alt="Zoëtry Mallorca"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">See full hotel page for Zoëtry Mallorca</p>
              <p className="text-xs text-slate-500">View wellness suites, golf options, prices and photos</p>
            </div>
            <Link
              to="/en/hotel/zoetry-mallorca"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>View hotel page</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-forum-boutique-hotel-spa',
    hotelId: 'forum-boutique-hotel-spa',
    title: '⭐ Hotel Inspection – Forum Boutique Hotel & Spa, Alcúdia 🌿',
    date: 'October 2025',
    category: 'Hotel inspections',
    categories: ['Hotel inspections', 'Accessible travel', 'Destinations', 'Practical info'],
    intro: 'An intimate, exclusive boutique hotel with a truly special family feeling – right in the heart of Alcúdia old town❤️ Forum Boutique Hotel & Spa is one of those hotels that genuinely made an impression on me. An intimate Adults Only (+18) boutique hotel with just 16 rooms.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/img-2260.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/img-2260.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejser's personal hotel inspection</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Forum Boutique Hotel & Spa</strong> • Area: Alcúdia (Old Town), Mallorca • Personally inspected by Alora Rejser
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          An intimate, exclusive boutique hotel with a truly special family feeling – right in the heart of Alcúdia's old town❤️
        </p>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Forum Boutique Hotel & Spa is one of those hotels that truly made a lasting impression on me.
        </p>

        <p>
          The hotel is an intimate Adults Only (+18) boutique hotel with just 16 rooms, and the moment you step inside, you sense that this is not a traditional mass holiday resort. It is personal, calm, and wonderfully cozy☀️
        </p>

        <div className="bg-amber-50/60 border border-amber-200/80 p-5 rounded-2xl space-y-3">
          <p className="font-medium text-amber-950">
            One of the things I noticed in particular during my visit was the truly special familial warmth.
          </p>
          <p className="text-amber-900">
            The staff are simply so kind, welcoming, and helpful🙏🏼
          </p>
          <p className="text-amber-900">
            You genuinely feel how much they care about their guests, and how far they go to make sure your stay is as smooth and delightful as possible🥰
          </p>
          <p className="text-amber-950 font-semibold">
            It is the kind of hotel where you truly feel seen and cared for👀
          </p>
        </div>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🌿 A beautifully executed, exclusive boutique gem</span>
          </h4>
          <p>
            Forum is housed in a lovingly restored historic building dating back to the late 16th / early 17th century🏰
          </p>
          <p>
            The historic Mallorca heritage has been carefully preserved with sandstone walls, arches, and ornate architectural details, alongside modern comforts.
          </p>
          <p className="font-medium text-slate-900">
            And the execution is exceptional!
          </p>
          <p>
            Guest rooms, public spaces, courtyard, and wellness areas flow harmoniously together, giving the atmosphere of a unified Mallorcan private residence rather than a generic hotel🤗
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
            <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00001_44553955.jpeg"
                alt="Forum Boutique Hotel entrance"
                className="w-full h-48 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-white">Historic stone entrance with terracotta potted plants</p>
            </div>
            <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00016_04a23503.jpeg"
                alt="Forum Boutique Hotel reception"
                className="w-full h-48 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-white">Atmospheric reception with authentic stone walls and arches</p>
            </div>
          </div>
        </div>

        <div className="bg-emerald-50 border border-emerald-200/80 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-emerald-950 text-lg flex items-center gap-2">
            <span>♿ The accessible room</span>
          </h4>
          <p className="text-emerald-900">
            The wheelchair-accessible room is situated conveniently on the ground floor, and in my opinion it is one of the coziest rooms in the entire hotel.
          </p>
          <p className="text-emerald-900 font-medium">
            Here you truly soak up authentic Mallorcan ambiance😍
          </p>
          <p className="text-emerald-900">
            The room is spacious with generous clearance around the bed, and the interior decor ties seamlessly into the rest of the hotel.
          </p>
          <p className="text-emerald-900">
            A shower chair can be provided through the hotel, and for guests requiring additional toilet support rails, Alora Rejser can arrange this prior to arrival🤩
          </p>
          <p className="text-emerald-950 font-semibold bg-white/70 p-3.5 rounded-xl border border-emerald-200">
            This allows us to customize your stay precisely to your individual accessibility needs🤗
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
            <div className="rounded-xl overflow-hidden border border-emerald-100 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00004_47e2eb94.jpeg"
                alt="Accessible bedroom with spacious layout"
                className="w-full h-48 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-white">Spacious ground-floor accessible room with generous clearance</p>
            </div>
            <div className="rounded-xl overflow-hidden border border-emerald-100 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00005_ff490f44.jpeg"
                alt="Step-free bathroom"
                className="w-full h-48 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-white">Step-free roll-in shower room with space for shower chair and rails</p>
            </div>
          </div>
        </div>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🏊 The charming courtyard and pool</span>
          </h4>
          <p>
            In the heart of the hotel lies the most delightful little courtyard with a small pool.
          </p>
          <p>
            It is not a huge resort pool – nor is it meant to be😊
          </p>
          <p className="font-medium text-slate-900">
            Here it is all about atmosphere, serenity, and charm🌸
          </p>
          <div className="p-4 bg-amber-50/90 rounded-xl border border-amber-300 text-amber-950 space-y-2">
            <div className="flex items-center gap-2 font-bold text-amber-900">
              <AlertCircle className="w-5 h-5 text-amber-700 shrink-0" />
              <span>Important note regarding accessibility: The pool has neither a pool lift nor a ramp.!</span>
            </div>
            <p className="text-xs sm:text-sm text-amber-900 leading-relaxed">
              It is therefore best suited for self-sufficient guests who can, for example, sit down on the edge and enter the water, or guests who can walk into the pool supported by the handrail.
            </p>
            <p className="text-xs sm:text-sm text-amber-900 font-medium">
              For a wheelchair user without this mobility, the pool will unfortunately not be accessible.
            </p>
          </div>
          <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs pt-1">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00008_0d5d2247.jpeg"
              alt="Courtyard and small pool"
              className="w-full h-56 object-cover"
            />
            <p className="text-[11px] text-slate-500 p-2 bg-white">Charming courtyard with small pool and Roman steps with handrail</p>
          </div>
        </div>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🧖‍♀️ Spa – ideal for an extended weekend</span>
          </h4>
          <p>
            It is also worth noting that Forum is a spa hotel, making it an exceptionally appealing choice for an extended weekend getaway.
          </p>
          <p>
            The hotel spa offers sauna, steam room, foot bath, sensation shower, and hydromassage. Therapeutic massages can also be booked in advance😍
          </p>
          <p>
            Therefore, the lack of an accessible outdoor pool lift doesn't have to be a barrier for enjoying a wonderful stay.
          </p>
          <p className="font-medium text-slate-900">
            You can easily choose Forum for the old town ambiance, the spa experience, the superb local dining, and a delightful weekend escape🤩
          </p>
          <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00011_a8e851d6.png"
              alt="Hotel spa area"
              className="w-full h-56 object-cover"
            />
            <p className="text-[11px] text-slate-500 p-2 bg-white">Wellness spa with sauna, hydromassage and relaxing ambiance</p>
          </div>
        </div>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>☕ Breakfast</span>
          </h4>
          <p>
            The stay includes a continental breakfast with traditional local produce and beverages, served from 8:00 to 10:30.
          </p>
          <p>
            The hotel does not have a traditional restaurant for lunch and dinner, but that is hardly a drawback here😌
          </p>
          <p className="font-medium text-slate-900">
            Because the moment you step outside, you find yourself right in one of the most vibrant culinary areas in Alcúdia.
          </p>
        </div>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>❤️ The location is truly special</span>
          </h4>
          <p>
            Forum is situated right in the heart of Alcúdia's old town.
          </p>
          <p>
            Turn the corner from the hotel, and you arrive almost directly at a large, lively square lined with outdoor restaurants and terraces🍛🥘👩‍🍳
          </p>
          <p>
            Turn left from the hotel, and you will find charming boutique shops – and a truly delicious artisan ice cream parlor😋
          </p>
          <p>
            Walk just a few steps in the opposite direction, and you reach a more secluded, sheltered square shaded by trees with intimate restaurants serving fantastic homemade pizza 🍕
          </p>
          <p className="font-medium text-slate-900">
            And that is how the whole neighborhood feels…
          </p>
          <p>
            Picturesque alleys, historic houses, cozy restaurants, cafés, artisan boutiques, and hidden plazas surround the property.
          </p>
          <p className="font-semibold text-emerald-900 bg-emerald-50/60 p-3.5 rounded-xl border border-emerald-100">
            You truly don't need a car to enjoy a memorable holiday here.
          </p>
        </div>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🚌 Beach & transportation</span>
          </h4>
          <p>
            If you fancy a full beach day, Alcúdia's expansive sandy beach is around 2.5 km away.
          </p>
          <p>
            Depending on individual mobility and assistance, some can walk or roll there, but there is also excellent public transport available.
          </p>
          <p>
            Around 5 minutes from the hotel lies Alcúdia's central bus station, with frequent buses heading toward the beach area. The buses are fully wheelchair accessible, with reliable connections throughout the day and evening🚌
          </p>
          <p className="font-medium text-slate-900">
            At the accessible section of the beach during the bathing season, amphibious beach wheelchair assistance into the water is available🏖️⛱️☀️
          </p>
        </div>

        <div className="bg-emerald-50/70 border border-emerald-200 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-emerald-950 text-lg flex items-center gap-2">
            <span>🌊 A trip to Port de Pollença</span>
          </h4>
          <p className="text-emerald-950">
            If you wish to explore further, Port de Pollença is only about 10 km away.
          </p>
          <p className="text-emerald-950">
            It is one of my personal favorite destinations on Mallorca, featuring a gorgeous seaside promenade, dining, boutiques, and lively yet relaxed ambiance🙏🏼
          </p>
          <p className="text-emerald-950">
            Alora Rejser also offers hotels here – including <Link to="/en/hotel/puerto-azul-suite-hotel" className="font-bold underline text-emerald-900 hover:text-emerald-700">Puerto Azul Suite Hotel</Link>.
          </p>
          <p className="text-emerald-950">
            This can be a great option for guests at Forum who wish to spend a day by a pool equipped with a pool lift, as Puerto Azul allows outside guests to purchase a day pass to their pool area.
          </p>
          <p className="text-emerald-950 font-semibold bg-white/80 p-4 rounded-xl border border-emerald-200">
            This makes it possible to combine the intimate boutique luxury of Alcúdia old town with a day at a fully accessible pool with lift🏊🏼‍♂️☀️
          </p>

          <div className="p-4 bg-white rounded-xl border border-emerald-200 flex flex-col sm:flex-row items-center justify-between gap-3 shadow-xs mt-2">
            <div>
              <p className="font-bold text-slate-900 text-sm">Puerto Azul Suite Hotel in Port de Pollença</p>
              <p className="text-xs text-slate-600">See the family-friendly hotel with large pool and pool lift only 90 m from the beach</p>
            </div>
            <Link
              to="/en/hotel/puerto-azul-suite-hotel"
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-emerald-700 hover:bg-emerald-800 text-white text-xs font-bold rounded-lg transition-all shrink-0 shadow-2xs"
            >
              <span>View Puerto Azul</span>
              <ArrowRight size={13} />
            </Link>
          </div>
        </div>

        <div className="bg-stone-50 border border-stone-200 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🌿 My verdict</span>
          </h4>
          <p>
            Forum Boutique Hotel & Spa is not for every wheelchair user, and it is crucial for me to be completely honest about that.
          </p>
          <p className="font-medium text-slate-900">
            The courtyard pool does not have a pool lift or ramp, so one must choose the hotel based on individual mobility and requirements. However, the property itself is completely step-free throughout 🙏🏼
          </p>
          <p>
            For the self-sufficient wheelchair user or guests with reduced mobility looking for an intimate alternative to large conventional accessible resorts, I think Forum is a fantastic little gem🤩
          </p>
          <p>
            To me, Forum proves that an accessible holiday doesn't always have to take place at a sprawling resort.
          </p>
          <p className="font-medium text-slate-900">
            Sometimes you just want to stay somewhere small, exquisite, and full of character – stepping straight outside in the evening into Mallorcan cobblestone streets, enjoying great food, sipping wine in the square, unwinding with spa treatments, and truly feeling immersed in Mallorca.
          </p>
          <p className="font-semibold text-emerald-900 bg-emerald-50/80 p-4 rounded-xl border border-emerald-100 text-base">
            That is exactly the experience Forum provides. 💚
          </p>
        </div>

        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00007_81f9117f.jpeg"
              alt="Forum Boutique Hotel and courtyard"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">See full hotel page for Forum Boutique Hotel & Spa</p>
              <p className="text-xs text-slate-500">View pricing, amenities, photo gallery and request an offer</p>
            </div>
            <Link
              to="/en/hotel/forum-boutique-hotel-spa"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>View hotel page</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-quartier-libre-marais',
    hotelId: 'quartier-libre-marais',
    title: '⭐ Hotel Inspection: Quartier Libre Marais, Paris ⭐️',
    date: 'August 2025',
    category: 'Hotel inspections',
    categories: ['Hotel inspections', 'Accessible travel', 'Destinations', 'Practical info'],
    intro: 'Quartier Libre Marais is a charming find for an accessible city break in Paris. Stay right in the heart of authentic Marais close to Notre-Dame, accessible RER and local bakeries.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/64fd0157-b6d3-4a32-92d8-543580f708a8.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/64fd0157-b6d3-4a32-92d8-543580f708a8.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejser's personal hotel inspection</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Quartier Libre Marais</strong> • Area: Marais, Paris, France
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Quartier Libre Marais is a wonderful base in central Paris with charming apartments, elevator, accessible bathroom and easy access to public transport and Disneyland Paris.
        </p>

        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/64fd0157-b6d3-4a32-92d8-543580f708a8.jpeg"
              alt="Quartier Libre Marais"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">See full hotel page for Quartier Libre Marais</p>
              <p className="text-xs text-slate-500">View apartment details, prices and amenities</p>
            </div>
            <Link
              to="/en/hotel/quartier-libre-marais"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>View hotel page</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'inspektion-puerto-azul-suite-hotel',
    hotelId: 'puerto-azul-suite-hotel',
    title: '⭐ Hotel Inspection: Puerto Azul Suite Hotel, Port de Pollença ⭐⭐⭐⭐',
    date: 'July 2025',
    category: 'Hotel inspections',
    categories: ['Hotel inspections', 'Accessible travel', 'Destinations', 'Practical info'],
    intro: 'Puerto Azul Suite Hotel is one of those hotels where accessibility is genuinely integrated into the entire resort – and not just in the accessible room🙏🏼 Read our personal inspection of the peaceful resort near Pine Walk, the spacious suite, and the bathroom with toilet backrest.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00001_6b74cabc.jpeg',
    imageLarge: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00001_6b74cabc.jpeg',
    content: (
      <div className="space-y-6 text-slate-700 leading-relaxed">
        <div className="bg-emerald-50/70 border border-emerald-100 p-5 rounded-2xl">
          <div className="flex items-center gap-2 text-emerald-800 font-bold text-sm mb-1">
            <Building2 size={18} />
            <span>Alora Rejser's personal hotel inspection</span>
          </div>
          <p className="text-xs text-slate-600">
            Hotel: <strong>Puerto Azul Suite Hotel</strong> • Area: Port de Pollença, Mallorca • Inspected personally by Alora Rejser
          </p>
        </div>

        <p className="text-base sm:text-lg font-medium text-slate-900">
          Puerto Azul Suite Hotel is one of those hotels where I truly experience that accessibility is integrated into the entire hotel – and not only in the accessible room🙏🏼
        </p>

        {/* 🌿 A calm and manageable resort */}
        <div className="bg-stone-50 border border-stone-200/80 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🌿 A peaceful and manageable resort</span>
          </h4>
          <p>
            Even though Puerto Azul features a large buffet restaurant and a lovely spacious pool area, I still experienced the hotel as surprisingly calm and manageable, right in the middle of July 🤗
          </p>
          <p>
            It does not feel like an overwhelming mega-resort with constant noise and chaos. On the contrary, I feel it has a very pleasant atmosphere where both families and couples can simply enjoy a relaxing holiday⛱️❤️
          </p>
        </div>

        {/* ♿ Here accessibility is truly thought through */}
        <div className="bg-emerald-50 border border-emerald-200/80 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-emerald-950 text-lg flex items-center gap-2">
            <span>♿ Here accessibility is truly thought through</span>
          </h4>
          <p className="text-slate-700">
            One of the things that made the deepest impression on me during my inspection was how attentive Puerto Azul is to guests with disabilities and reduced mobility🙏🏼
          </p>
          <p className="text-slate-700">
            They have genuinely done what they can to incorporate accessibility into daily life at the hotel and into the way guests navigate the resort!
          </p>
          <p className="text-slate-700">
            And this does not apply only to the most obvious places like the reception, restaurant, and pool area.
          </p>
          <p className="text-slate-700">
            When the family walks down toward the table tennis area or the children's playground, access has been considered as well.
          </p>
          <div className="bg-white/80 border border-emerald-300 p-4 rounded-xl space-y-2">
            <p className="font-bold text-emerald-900">
              This means a lot to me!
            </p>
            <p className="text-emerald-950 italic text-sm">
              Because holidays are also about everyone being included. A child or an adult in a wheelchair should not be left behind because the rest of the family moves to an inaccessible area🥺
            </p>
          </div>
          <p className="text-slate-700">
            In my assessment, the ramps are very good. They are wide, smooth to ride on, and do not feel unnecessarily steep. Therefore, I believe the hotel works really well for both wheelchair users and guests with walking difficulties.
          </p>
        </div>

        {/* 🛏️ The accessible suite */}
        <div className="space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🛏️ The accessible suite</span>
          </h4>
          <p>
            The accessible suite is spacious and exceptionally well laid out🤗
          </p>
          <p>
            There is a separate bedroom and living area, and you step out completely step-free onto the terrace, which is super cozy and offers plenty of room for a wheelchair🌸
          </p>
          <p>
            The hotel's suites can generally accommodate up to 4 people. When booking the accessible suite, I always verify the specific occupancy with the hotel to ensure the room fits the individual family.
          </p>
          <p>
            There are no cooking facilities in the room.
          </p>
          <p>
            On the other hand, there is a small practical niche with a refrigerator and coffee and tea facilities, as well as a small table with four seats for relaxing or enjoying takeaway meals🥰
          </p>
          <p>
            And if you don't feel like making anything yourself, the hotel's large buffet restaurant is naturally right at hand👩‍🍳
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
            <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00041_d13d5009.png"
                alt="Puerto Azul Suite Hotel accessible bedroom"
                className="w-full h-48 sm:h-56 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-stone-50 text-center">Spacious suite with bed area and dining table</p>
            </div>
            <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00007_1b62b57d.jpeg"
                alt="Puerto Azul Suite Hotel step-free terrace"
                className="w-full h-48 sm:h-56 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-stone-50 text-center">Step-free access onto the private terrace with table and chairs</p>
            </div>
          </div>
        </div>

        {/* 🚿 An exceptional accessible bathroom */}
        <div className="bg-emerald-50/60 border border-emerald-200/80 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🚿 An exceptional accessible bathroom</span>
          </h4>
          <p>
            In my assessment, the bathroom is one of the standout highlights at Puerto Azul🤩
          </p>
          <p>
            It is one of the larger accessible bathrooms I have seen.
          </p>
          <p>
            There is plenty of turning space for maneuvering with a wheelchair, and room if you need a shower chair.
          </p>
          <div className="bg-white/80 border border-emerald-300 p-4 rounded-xl space-y-2">
            <p className="font-bold text-emerald-900">
              And then they have a thoughtful detail that I very rarely see:
            </p>
            <p className="text-slate-800">
              <strong>There is a backrest/cushion behind the toilet.</strong>
            </p>
            <p className="text-xs text-slate-600">
              For many guests, this can make a significant difference, and it is another prime example that the hotel genuinely thinks about real practical needs.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-1">
            <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00010_ba448f08.jpeg"
                alt="Puerto Azul accessible bathroom with roll-under sink and roll-in shower"
                className="w-full h-48 sm:h-56 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-stone-50 text-center">Spacious bathroom with roll-under sink, grab rails, and fold-down shower seat</p>
            </div>
            <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00009_9ba9a516.jpeg"
                alt="Toilet with backrest cushion and grab rails at Puerto Azul"
                className="w-full h-48 sm:h-56 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-stone-50 text-center">Accessible toilet with fold-down grab bars and padded backrest</p>
            </div>
          </div>
        </div>

        {/* 🏊 The pool area – with one important limitation */}
        <div className="space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🏊 The pool area – with one important limitation</span>
          </h4>
          <p>
            The hotel has a lovely large pool area with an adult pool and a separate section for children.
          </p>
          <p>
            There is a pool lift, so wheelchair users and guests with reduced mobility have easy access to the water☀️
          </p>

          <div className="bg-amber-50 border border-amber-200 p-4 rounded-xl space-y-2 text-amber-900 text-sm">
            <p className="font-bold flex items-center gap-1.5 text-amber-950">
              <AlertCircle size={17} className="text-amber-700 shrink-0" />
              Important point of note regarding the pool:
            </p>
            <p className="font-semibold text-amber-950">
              There is no ramp down into the pool.
            </p>
            <p>
              If you depend on or prefer a pool ramp rather than a pool lift, you should be aware of this!
            </p>
          </div>

          <p>
            The area around the pool, however, is very nicely accessible.
          </p>

          <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00003_4cf773dc.jpeg"
              alt="Puerto Azul pool area with palm trees"
              className="w-full h-56 sm:h-72 object-cover"
            />
            <p className="text-[11px] text-slate-500 p-2 bg-stone-50 text-center">Inviting pool area surrounded by palm trees and spacious sun terrace</p>
          </div>
        </div>

        {/* 🍴 Restaurant and resort life🤗 */}
        <div className="bg-stone-50 border border-stone-200/80 p-6 rounded-2xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🍴 Restaurant and resort life🤗</span>
          </h4>
          <p>
            Puerto Azul features a large buffet restaurant with show cooking and a varied selection of delicious dishes😋🥘
          </p>
          <p>
            By the pool area there is also a snack bar, and the hotel offers various activities for both children and adults.
          </p>
          <p>
            Facilities include a playground, MiniClub, gym, and varied entertainment☀️
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
            <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00052_1552a201.jpeg"
                alt="Puerto Azul buffet restaurant"
                className="w-full h-44 sm:h-48 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-white text-center">Bright buffet restaurant with generous space between tables</p>
            </div>
            <div className="rounded-xl overflow-hidden border border-stone-200 shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00004_eb4214e8.jpeg"
                alt="Puerto Azul poolside snack bar"
                className="w-full h-44 sm:h-48 object-cover"
              />
              <p className="text-[11px] text-slate-500 p-2 bg-white text-center">Cozy poolside snack and terrace bar</p>
            </div>
          </div>
        </div>

        {/* 🌴 The location is a huge plus */}
        <div className="space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-lg flex items-center gap-2">
            <span>🌴 The location is a huge plus</span>
          </h4>
          <p className="text-slate-900 font-medium">
            And now we come to something I truly love about Puerto Azul:
          </p>
          <p className="text-xl font-bold text-slate-900">
            The location! !
          </p>
          <p>
            The hotel is situated right in the prime sweet spot of Port de Pollença😍
          </p>
          <p>
            You practically just step out the front door, walk one block down, and you are right at Pine Walk, the beach, and all the vibrant life along the waterfront.
          </p>
          <p>
            Remember to look down the side streets on your way down👀
          </p>
          <p>
            For some of the coziest spots in Port de Pollença are small places you might almost walk past😌 There are restaurants tucked away in intimate courtyards and pedestrian passages, and the town is full of hidden treasures. That is part of the charm that I personally think makes Port de Pollença so special🤩
          </p>
          <p>
            There are also several small local supermarkets located right around the hotel😊
          </p>
          <p>
            Among others, there is a SPAR supermarket right behind the hotel where you can find virtually everything you need for your holiday. The shop I visited also had a ramp and was easily accessible by wheelchair🙏🏼
          </p>
          <p className="font-medium text-slate-900">
            So you have the beach, Pine Walk, restaurants, shops, and town life right outside your door – while being able to retreat to a peaceful resort❤️
          </p>
        </div>

        {/* 💚 My overall assessment */}
        <div className="bg-[#99A18C]/15 border border-[#99A18C]/30 p-6 sm:p-8 rounded-3xl space-y-4">
          <h4 className="font-serif font-bold text-slate-900 text-xl flex items-center gap-2">
            <span>💚 My overall assessment</span>
          </h4>
          <p className="text-slate-800 font-semibold text-base sm:text-lg">
            Puerto Azul is a hotel I am very eager to recommend to my guests.
          </p>
          <p className="text-slate-700">
            This is not just because of the large accessible bathroom, the pool lift, or the good ramps🙏🏼
          </p>
          <p className="text-slate-900 font-medium">
            It is the complete picture that works so well.
          </p>
          <p className="text-slate-700">
            I experience a hotel that has genuinely tried to think through how a guest with a disability or reduced mobility can be an active part of the holiday and move around together with the whole family🤗
          </p>
          <p className="text-slate-700">
            At the same time, you get a generous pool area, buffet restaurant, activities for both kids and adults, and an exceptional location in Port de Pollença – without the hotel feeling like an impersonal mega-resort.
          </p>
        </div>

        {/* ⚠️ Good to know */}
        <div className="bg-amber-50/70 border border-amber-200/80 p-6 rounded-2xl space-y-3">
          <h4 className="font-serif font-bold text-amber-950 text-lg flex items-center gap-2">
            <span>⚠️ Good to know</span>
          </h4>
          <p className="text-amber-900">
            Puerto Azul is a very popular hotel, and accessible suites are limited.
          </p>
          <p className="text-amber-950 font-medium">
            Therefore, I recommend booking well in advance, particularly if you wish to travel during school holidays or peak weeks🙏🏼
          </p>
          <p className="text-slate-800 pt-2 font-medium">
            To me, Puerto Azul is a great example that a family-oriented hotel can offer extensive facilities while remaining cozy, manageable, and accessible.
          </p>
          <p className="text-emerald-950 font-bold text-base sm:text-lg pt-1">
            Holidays should feel like holidays – for everyone ❤️
          </p>
        </div>

        {/* Bottom banner + link */}
        <div className="mt-8 pt-6 border-t border-slate-200/80 space-y-4">
          <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200 bg-stone-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=90,format=auto/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/image00001_6b74cabc.jpeg"
              alt="Puerto Azul Suite Hotel Port de Pollença"
              className="w-full h-auto max-h-[500px] object-cover"
            />
          </div>
          <div className="p-5 bg-stone-50 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-slate-800 text-sm">See full hotel page for Puerto Azul Suite Hotel</p>
              <p className="text-xs text-slate-500">View suites, photo gallery, rates and location in Port de Pollença</p>
            </div>
            <Link
              to="/en/hotel/puerto-azul-suite-hotel"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#99A18C] hover:bg-[#8a917e] text-white text-xs font-bold rounded-xl transition-all shadow-sm hover:shadow"
            >
              <span>View hotel page</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    )
  }
];
